var _defs, _text, _text2, _text3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _polygon, _text4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _rect562, _rect563, _rect564, _rect565, _rect566, _rect567, _rect568, _rect569, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _rect586, _rect587, _rect588, _rect589, _rect590, _rect591, _rect592, _rect593, _rect594, _rect595, _rect596, _rect597, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _rect604, _rect605, _rect606, _rect607, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _rect619, _rect620, _rect621, _rect622, _rect623, _rect624, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _rect636, _rect637, _rect638, _rect639, _rect640, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _rect657, _rect658, _rect659, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _rect672, _rect673, _rect674, _rect675, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _rect689, _rect690, _rect691, _rect692, _rect693, _rect694, _rect695, _rect696, _rect697, _rect698, _rect699, _rect700, _rect701, _rect702, _rect703, _rect704, _rect705, _rect706, _rect707, _rect708, _rect709, _rect710, _rect711, _rect712, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _rect725, _rect726, _rect727, _rect728, _rect729, _rect730, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _rect744, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _rect762, _rect763, _rect764, _rect765, _rect766, _rect767, _rect768, _rect769, _rect770, _rect771, _rect772, _rect773, _rect774, _rect775, _rect776, _rect777, _rect778, _rect779, _rect780, _rect781, _rect782, _rect783, _rect784, _rect785, _rect786, _rect787, _rect788, _rect789, _rect790, _rect791, _rect792, _rect793, _rect794, _rect795, _rect796, _rect797, _rect798, _rect799, _rect800, _rect801, _rect802, _rect803, _rect804, _rect805, _rect806, _rect807, _rect808, _rect809, _rect810, _rect811, _rect812, _rect813, _rect814, _rect815, _rect816, _rect817, _rect818, _rect819, _rect820, _rect821, _rect822, _rect823, _rect824, _rect825, _rect826, _rect827, _rect828, _rect829, _rect830, _rect831, _rect832, _rect833, _rect834, _rect835, _rect836, _rect837, _rect838, _rect839, _rect840, _rect841, _rect842, _rect843, _rect844, _rect845, _rect846, _rect847, _rect848, _rect849, _rect850, _rect851, _rect852, _rect853, _rect854, _rect855, _rect856, _rect857, _rect858, _rect859, _rect860, _rect861, _rect862, _rect863, _rect864, _rect865, _rect866, _rect867, _rect868, _rect869, _rect870, _rect871, _rect872, _rect873, _rect874, _rect875, _rect876, _rect877, _rect878, _rect879, _rect880, _rect881, _rect882, _rect883, _rect884, _rect885, _rect886, _rect887, _rect888, _rect889, _rect890, _rect891, _rect892, _rect893, _rect894, _rect895, _rect896, _rect897, _rect898, _rect899, _rect900, _rect901, _rect902, _rect903, _rect904, _rect905, _rect906, _rect907, _rect908, _rect909, _rect910, _rect911, _rect912, _rect913, _rect914, _rect915, _rect916, _rect917, _rect918, _rect919, _rect920, _rect921, _rect922, _rect923, _rect924, _rect925, _rect926, _rect927, _rect928, _rect929, _rect930, _rect931, _rect932, _rect933, _rect934, _rect935, _rect936, _rect937, _rect938, _rect939, _rect940, _rect941, _rect942, _rect943, _rect944, _rect945, _rect946, _rect947, _rect948, _rect949, _rect950, _rect951, _rect952, _rect953, _rect954, _rect955, _rect956, _rect957, _rect958, _rect959, _rect960, _rect961, _rect962, _rect963, _rect964, _rect965, _rect966, _rect967, _rect968, _rect969, _rect970, _rect971, _rect972, _rect973, _rect974, _rect975, _rect976, _rect977, _rect978, _rect979, _rect980, _rect981, _rect982, _rect983, _rect984, _rect985, _rect986, _rect987, _rect988, _rect989, _rect990, _rect991, _rect992, _rect993, _rect994, _rect995, _rect996, _rect997, _rect998, _rect999, _rect1000, _rect1001, _rect1002, _rect1003, _rect1004, _rect1005, _rect1006, _rect1007, _rect1008, _rect1009, _rect1010, _rect1011, _rect1012, _rect1013, _rect1014, _rect1015, _rect1016, _rect1017, _rect1018, _rect1019, _rect1020, _rect1021, _rect1022, _rect1023, _rect1024, _rect1025, _rect1026, _rect1027, _rect1028, _rect1029, _rect1030, _rect1031, _rect1032, _rect1033, _rect1034, _rect1035, _rect1036, _rect1037, _rect1038, _rect1039, _rect1040, _rect1041, _rect1042, _rect1043, _rect1044, _rect1045, _rect1046, _rect1047, _rect1048, _rect1049, _rect1050, _rect1051, _rect1052, _rect1053, _rect1054, _rect1055, _rect1056, _rect1057, _rect1058, _rect1059, _rect1060, _rect1061, _rect1062, _rect1063, _rect1064, _rect1065, _rect1066, _rect1067, _rect1068, _rect1069, _rect1070, _rect1071, _rect1072, _rect1073, _rect1074, _rect1075, _rect1076, _rect1077, _rect1078, _rect1079, _rect1080, _rect1081, _rect1082, _rect1083, _rect1084, _rect1085, _rect1086, _rect1087, _rect1088, _rect1089, _rect1090, _rect1091, _rect1092, _rect1093, _rect1094, _rect1095, _rect1096, _rect1097, _rect1098, _rect1099, _rect1100, _rect1101, _rect1102, _rect1103, _rect1104, _rect1105, _rect1106, _rect1107, _rect1108, _rect1109, _rect1110, _rect1111, _rect1112, _rect1113, _rect1114, _rect1115, _rect1116, _rect1117, _rect1118, _rect1119, _rect1120, _rect1121, _rect1122, _rect1123, _rect1124, _rect1125, _rect1126, _rect1127, _rect1128, _rect1129, _rect1130, _rect1131, _rect1132, _rect1133, _rect1134, _rect1135, _rect1136, _rect1137, _rect1138, _rect1139, _rect1140, _rect1141, _rect1142, _rect1143, _rect1144, _rect1145, _rect1146, _rect1147, _rect1148, _rect1149, _rect1150, _rect1151, _rect1152, _rect1153, _rect1154, _rect1155, _rect1156, _rect1157, _rect1158, _rect1159, _rect1160, _rect1161, _rect1162, _rect1163, _rect1164, _rect1165, _rect1166, _rect1167, _rect1168, _rect1169, _rect1170, _rect1171, _rect1172, _rect1173, _rect1174, _rect1175, _rect1176, _rect1177, _rect1178, _rect1179, _rect1180, _rect1181, _rect1182, _rect1183, _rect1184, _rect1185, _rect1186, _rect1187, _rect1188, _rect1189, _rect1190, _rect1191, _rect1192, _rect1193, _rect1194, _rect1195, _rect1196, _rect1197, _rect1198, _rect1199, _rect1200, _rect1201, _rect1202, _rect1203, _rect1204, _rect1205, _rect1206, _rect1207, _rect1208, _rect1209, _rect1210, _rect1211, _rect1212, _rect1213, _rect1214, _rect1215, _rect1216, _rect1217, _rect1218, _rect1219, _rect1220, _rect1221, _rect1222, _rect1223, _rect1224, _rect1225, _rect1226, _rect1227, _rect1228, _rect1229, _rect1230, _rect1231, _rect1232, _rect1233, _rect1234, _rect1235, _rect1236, _rect1237, _rect1238, _rect1239, _rect1240, _rect1241, _rect1242, _rect1243, _rect1244, _rect1245, _rect1246, _rect1247, _rect1248, _rect1249, _rect1250, _rect1251, _rect1252, _rect1253, _rect1254, _rect1255, _rect1256, _rect1257, _rect1258, _rect1259, _rect1260, _rect1261, _rect1262, _rect1263, _rect1264, _rect1265, _rect1266, _rect1267, _rect1268, _rect1269, _rect1270, _rect1271, _rect1272, _rect1273, _rect1274, _rect1275, _rect1276, _rect1277, _rect1278, _rect1279, _rect1280, _rect1281, _rect1282, _rect1283, _rect1284, _rect1285, _rect1286, _rect1287, _rect1288, _rect1289, _rect1290, _rect1291, _rect1292, _rect1293, _rect1294, _rect1295, _rect1296, _rect1297, _rect1298, _rect1299, _rect1300, _rect1301, _rect1302, _rect1303, _rect1304, _rect1305, _rect1306, _rect1307, _rect1308, _rect1309, _rect1310, _rect1311, _rect1312, _rect1313, _rect1314, _rect1315, _rect1316, _rect1317, _rect1318, _rect1319, _rect1320, _rect1321, _rect1322, _rect1323, _rect1324, _rect1325, _rect1326, _rect1327, _rect1328, _rect1329, _rect1330, _rect1331, _rect1332, _rect1333, _rect1334, _rect1335, _rect1336, _rect1337, _rect1338, _rect1339, _rect1340, _rect1341, _rect1342, _rect1343, _rect1344, _rect1345, _rect1346, _rect1347, _rect1348, _rect1349, _rect1350, _rect1351, _rect1352, _rect1353, _rect1354, _rect1355, _rect1356, _rect1357, _rect1358, _rect1359, _rect1360, _rect1361, _rect1362, _rect1363, _rect1364, _rect1365, _rect1366, _rect1367, _rect1368, _rect1369, _rect1370, _rect1371, _rect1372, _rect1373, _rect1374, _rect1375, _rect1376, _rect1377, _rect1378, _rect1379, _rect1380, _rect1381, _rect1382, _rect1383, _rect1384, _rect1385, _rect1386, _rect1387, _polygon2, _text5, _text6, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _rect1388;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 339.51 268.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{font-size:8px;}.cls-1,.cls-27,.cls-4,.cls-6{fill:#231f20;}.cls-1{font-family:ProximaNova-Light, Proxima Nova;font-weight:300;}.cls-2,.cls-23{fill:#812990;}.cls-3{fill:#6b7b84;}.cls-5{fill:url(#linear-gradient);}.cls-27,.cls-6{font-family:ProximaNova-Bold, Proxima Nova;font-weight:700;}.cls-7{font-size:7.5px;}.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-7{font-family:ProximaNova-Regular, Proxima Nova;font-weight:400;}.cls-8{letter-spacing:-0.01em;}.cls-9{letter-spacing:-0.02em;}.cls-10{letter-spacing:-0.03em;}.cls-11{letter-spacing:-0.02em;}.cls-12{letter-spacing:-0.01em;}.cls-13{letter-spacing:-0.03em;}.cls-14{letter-spacing:0em;}.cls-15{letter-spacing:-0.01em;}.cls-16{letter-spacing:-0.05em;}.cls-17{letter-spacing:-0.04em;}.cls-18{letter-spacing:-0.01em;}.cls-19{letter-spacing:0em;}.cls-20,.cls-21{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-20{stroke:#ffcb05;}.cls-21{stroke:#6b7b84;}.cls-22{fill:url(#linear-gradient-2);}.cls-23{font-size:16.57px;font-family:ProximaNova-Black, Proxima Nova;font-weight:800;}.cls-24{letter-spacing:-0.02em;}.cls-25{letter-spacing:-0.06em;}.cls-26{letter-spacing:-0.01em;}.cls-27{font-size:7px;}.cls-28{letter-spacing:-0.01em;}.cls-29{letter-spacing:-0.01em;}.cls-31{letter-spacing:-0.09em;}.cls-32{letter-spacing:0em;}.cls-33{letter-spacing:-0.02em;}.cls-34{letter-spacing:-0.01em;}.cls-35{letter-spacing:-0.08em;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 106.58,
    y1: 228.9,
    x2: 156.19,
    y2: 228.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812990"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 289.78,
    y1: 228.9,
    x2: 339.38,
    y2: 228.9,
    xlinkHref: "#linear-gradient"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 266.1)"
  }, "Front")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(183.2 266.1)"
  }, "Back")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(270.11 266.1)"
  }, "Size: 5.5cm x 8.8cm")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.07,69.73l-.92.13a2.93,2.93,0,0,1-.45.1c-.35,0-.54-.44-1-.54-.12,0,0,0-.18-.06s.06,0-.24-.11c0,.32-.07.23-.07.48a1.9,1.9,0,0,0,.21.84c.09.18.13.12.12.38a1.69,1.69,0,0,0,.14,1,2.67,2.67,0,0,1,.36.74c.49,0,.42,0,.48.14.45,0,.16-.1.41-.14,0,0,.47.11.34-.47.35.09.19.27.41.25s.09-.17.12-.38-.09-.06.23-.21l-.07-.42c0-.48.11,0,.27.07l.21-1.45c0-.11.15-.06-.14-.47C55,69.7,55.14,69.71,55.07,69.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.2,68.5c-.05.19.11.11-.13.13l.27.62a.45.45,0,0,1,.28-.06c0-.42,0-.27-.14-.49S55.39,68.54,55.2,68.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.77,68c-.07.28,0,0-.09.22s-.12.62.29.39C52,68.08,52,68.12,51.77,68Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.48,63.09a2.56,2.56,0,0,0-.84.13c-.5.13-.28.24-.12.48a3.07,3.07,0,0,0,1.19-.17c.22,0,.24,0,.11-.24h-.34Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.38,59.72a2,2,0,0,0-.06-.23l-.78-.29-1.66-.63c-.49-.2-1.13-.46-1.75-.77s-1.34-.68-2-1.11a4.53,4.53,0,0,1-1.66-1.89,5.88,5.88,0,0,1-.38-.95h-.13a3.37,3.37,0,0,0-.75.1q-.36.07-.72.18a9.37,9.37,0,0,1-1.91.36H48.3l-.73,0-.54,0c-.41,0-.79-.13-1.15-.21l-.41-.09c-.1.13-.2.25-.31.37a1,1,0,0,1,.21.19,1.39,1.39,0,0,1,.29,1.35,2.07,2.07,0,0,1-1.79,1.32l-.66,0H43.1a2.18,2.18,0,0,1-1.76-1.15,1.55,1.55,0,0,1,.12-1.72l0-.06.28-.42a3.78,3.78,0,0,0,.5-.87,2.36,2.36,0,0,1-2-1.49,5.08,5.08,0,0,1-.3-1.44l-.2.06-.31.08a2.64,2.64,0,0,1-.28.29,1.71,1.71,0,0,1-1.22.58,1.66,1.66,0,0,1-.48-.08h-.08a1.6,1.6,0,0,1-.91-.28,1.16,1.16,0,0,1-.51-.36,1.18,1.18,0,0,1-.23-1,4.21,4.21,0,0,1,.78-1.7.94.94,0,0,0,.1-.14,1.61,1.61,0,0,1,.47-1c.21-.2.42-.38.63-.56l.16-.14a3.93,3.93,0,0,1,.35-.27,2.08,2.08,0,0,1,.33-.91,3.71,3.71,0,0,1,1.13-1.1,7.45,7.45,0,0,1,.7-.41l.35-.19.31-.2.19-.11a1,1,0,0,1,.54-.16,1.09,1.09,0,0,1,1,1.34s-.27.9-.35,1.2a2.66,2.66,0,0,1-.51.95c.23.14.49.31.75.5a5.16,5.16,0,0,1,.58.55h.45l.15,0a4,4,0,0,0,1.09-.5l.15-.09a9.84,9.84,0,0,1,2.14-1,14.94,14.94,0,0,1,3.8-.53h.5c.7,0,1.41,0,2.06.07a12.58,12.58,0,0,1,1.58.22A9.24,9.24,0,0,1,59,47a.68.68,0,0,0-.37-.52c-.21-.09-.1,0-.25-.12s0,0,0,0l-.15-.13c-.24-.15-.2,0-.29-.33l-.09.05,0,0c-.15,0-.1-.27-.24-.44s.06.13-.3-.05c-.19-.09,0,0-.11-.08a.3.3,0,0,0-.14-.07l-.12,0c-.57-.23-.46-.32-.46-.9-.49-.13-.2-.5-.17-.81.06-.5-.24-.57-.12-1.11-.67,0-.4-.67-.59-1.4l0-.66c0-.14,0,.06.08-.19l-.18-.09c-.65-.39-.52-.69-.71-.81l-.48.15c-.14.1,0,.07-.21.12-.45-.42-.24-1.3-.39-1.87-.06-.24-.11-.57-.44-.65a1.18,1.18,0,0,1,.21-.42c-.17-.08-.25-.06-.41-.14a2,2,0,0,0-.21-1.09c-.13-.22,0-.24-.34-.27-.08.32-.05.13-.35.27a1.92,1.92,0,0,1-.25,1s0,0,0,0l-.06.08a1.41,1.41,0,0,0-.28.68h.2c0,.31,0,.13-.15.32s-.08,0,0,.34-.24.39-.21.77.11.17.1.41-.07.2-.06.39c0,.52.21.39,0,.88s-.15,1-.47,1.52a6.49,6.49,0,0,0-.35.74,1,1,0,0,1-.78.3,3.45,3.45,0,0,1-.7-.34c-.13-.07-.23-.11-.29-.24s0-.09-.08-.2c-.16-.34-.62-.31-.94-.43s-.44-.59-1.23-.9l-.41-.13-.33-.22-.26-.29c-.08-.07-.22-.15-.32-.23l-.3-.19c-.27-.15-.23,0-.24-.38.15,0,.33-.33.46-.51s0,0,.08-.12l.06-.15,0,0,.14-.35c-.28-.11,0,.06-.27-.07.11-.16.08-.07.14-.27.35-.17.26-.07.47,0,.42-.6.17-.22.27-.57s.28-.36.42-.58l-.25-.17c-.29-.15-.23.12-.23-.39a1.27,1.27,0,0,0-.55.41c-.07-.09-.07.15-.07-.2a1,1,0,0,1-.34.13c.2-.26.11,0,.21-.27a1.75,1.75,0,0,0-.9.34c-.17-.12-.27-.11-.34-.34-.35,0-.1,0-.41.14A1.59,1.59,0,0,0,43,36v-.13c-.37,0-.61.23-.92-.12,0,0-.15-.25-.18-.29-.26.07-.15.07-.35.2a.53.53,0,0,0-.3-.38c-.11-.07,0,0-.14,0l-.38,0c-.06,0,.1,0-.21.06v.21c.27.06,0,0,.19.08l.06,0,0,0c.2.09.22,0,.54,0a1.54,1.54,0,0,1,.13.62l-.5.17,0,0-.62.07c-.26,0-.17-.06-.27-.26l-.18.09-.17.1c-.21.16.1.06-.24.19a.63.63,0,0,1-.31,0c0,.18,0,.17-.15.39s0,.2-.33.23c0,.49.05.21.14.54l-.23.08c-.34.08-.18.08-.3.43s-.29.1-.43.73c.22.15.27.15.31.29a.54.54,0,0,1,0,.25c-.66-.05-.36,0-.6,0a2.64,2.64,0,0,0-.77-.12c0,.51,0,.16-.14.3l0,0-.1.16c0-.48.1-.14.13-.55-.58-.16-.56-.77-1.14-.87s0-.14-.51-.15c-.12.25,0,.3-.27.47.07-.32,0-.1,0-.2-.25.06-.15.07-.35.2,0-.31-.08-.26-.34-.13.05.2,0,.14.2.2a.8.8,0,0,0-.14.41l-.4-.34c-.18.35,0,.23-.26.42l-.1.05a2.43,2.43,0,0,0-.2.14c.1.38.18.07.07.35-.23,0-.25.1-.41.31l0,0-.05.06-.11.1c-.1.09-.22.13-.25.34a.6.6,0,0,0,.17.39c-.15.19-.13.12-.14.42l-.31-.1c-.31-.07-.15.17-.24-.1h-.34c0,.46-.17.35-.07.55s.25.17.41.4c-.17.07-.06.05-.27,0,0,.36.08.12,0,.48-.21-.15-.1-.11-.35-.55s-.25-.15-.21-.61c-.28.08-.26.22-.4.41l-.33.35A1.11,1.11,0,0,0,30,43c0,.2.12.31.12.67.05,0,0,0,0,0l.18,0c0,.15,0,.08-.1.18l-.07.07c-.1.11,0,0-.11.1l-.11.09,0,0-.08.06c-.17.14-.13.16-.21.34l0,.1c-.41,1.08-.67,1.08-1.89,1.55-.23.08,0,.05-.25.07s-.18-.17-.47,0-.05.16-.27.34-.39-.11-1,.54a.55.55,0,0,1-.42.17c-.36,0-.09-.2-.55.1,0-.36.07-.13-.13-.21-.06.22-.05.18-.23.32-.42.32-.08-.09-.68.57l-.07.07-.21.26-.06.08c-.32.36-1,.21-1,1.31h-.2a4.81,4.81,0,0,1-.07-.76,1.58,1.58,0,0,0-.49,1.23c.22.08.06-.11.18.17a.94.94,0,0,1,0,.85,1.09,1.09,0,0,0-.13.37v.49c0,.16.06.11.22.3s0,.26.36.61l0,0c.08.1.09.13.17.24.27.35.38.17.38,1h-.14a1.09,1.09,0,0,0-.76-.9c0,.63.18.21.22.68-.16-.1-.07-.08-.28-.13,0,.36.06.12-.14.21.45.66,1.14.91,1.32,1.77.07.38.47.58.61.9s0,0,.11.22.13.12.21.2a1,1,0,0,1,.24.6c.23,1.45,1.11,1.75,1.2,2.61v.52c0,.3,0,.25.11.55s0,.4-.1.63a1.68,1.68,0,0,1-.41-.06c0,.5,0,.95.43.94s.78.7,1.72.54a3.6,3.6,0,0,0,1.05-.13c.28-.16.31-.32.41-.43l0,0,.1-.11.06-.07.2-.12c.16,0,.42,0,.49-.24,0,0,0-.11,0-.13.1-.39.64-.38,1-.5l.78-.11h.17c.25,0-.07,0,.18,0l.1,0,0,0c.24.11-.18.06.25.09.06-.15.14-.23.58-.22s.79.21,1-.71a.72.72,0,0,1,.13-.36c.17-.2.28-.11.55-.27,1.09-.63.67-.74,1.91-.76a3.58,3.58,0,0,0,1.31-.4c.81-.33.73-.56,2-.56a3.12,3.12,0,0,0,.79-.11c.3-.05.91.43,1.14.59.39-.11.18-.29.67,0,.29.17.49.11.84.19.09.21,0,0,0,.34.22-.05.22-.09.41,0-.06.15-.13.1-.17.25l.14.39c.17.15.3,0,.47.21a4.67,4.67,0,0,0,.37.61,1.11,1.11,0,0,1,.22.66h-.1L44,62c.41,0,.3.31.67.4.13,0,0,0,.14,0s0,0,.15.06l0-.28c-.06-.21,0-.27.4-.74s.73-.32.92-.67a1.65,1.65,0,0,1,.3-.52c.17-.18.05.07.15-.19,0,.05,0,0,0,0s0,0,.06.08a1.16,1.16,0,0,1,.11.16c-.2,0-.17,0-.27.13.14.32.15.28,0,.47A1.61,1.61,0,0,0,46.27,62c0,.41-.09.32-.48.32-.06.25-.11.19-.14.48a1.6,1.6,0,0,0,.49-.14c.29-.07.32.16.48-.2l.27-.83.14.21s0,0,0,0l.05.09,0,0c.38.78-.26.8-.3,1.25a2.22,2.22,0,0,0,.69-.13s0,0,0,0,0,0,0,0c.42.36.88.84.69,1.46,0,0,0,0,0,0l0,.34a1.25,1.25,0,0,0,.29.44l.28.46c.21.23.53.13.77.4l.19.22c.2-.07.2-.15.42-.09l.15.06.06,0c.18.05.09,0,.26.08s.7.39.76.55c.38,0,1.12-1,1.3-.28.34,0,.35-.24.63-.27l-.06.09c-.09.2,0-.12-.09.25l.33.3.1.1.21.08a.56.56,0,0,1,.12.28.33.33,0,0,0,.2-.48c.81,0,1-.81,1.9-.78.56,0,1,.19,1.39-.13l.15-.19c.1-.24,0-.3,0-.51l.36-1a1.35,1.35,0,0,1,.73-.89c.2-.17,0-.05.07-.18v-.05l0-.18a1.39,1.39,0,0,1,.37-.65c.41-.33.23-.57.84-1.22l.39-.22,0,0,.14-.1C60.56,60.67,60.48,60.2,60.38,59.72Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.16,43.76Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.81,48.15a8.78,8.78,0,0,0-.69-.68c-.34-.25-.7-.47-1.06-.69a2.31,2.31,0,0,0-.54-.2.91.91,0,0,0-.33,0,2.21,2.21,0,0,1,.57-.65,2,2,0,0,0,.76-1c.11-.4.23-.8.34-1.2l0,0L41.3,44c-.34.19-.68.36-1,.57a2.87,2.87,0,0,0-.83.8,1.23,1.23,0,0,0-.16.84c0,.2-.1.2-.1.2a1.4,1.4,0,0,0-.6.36c-.25.22-.5.42-.73.65a.63.63,0,0,0-.19.37,1.11,1.11,0,0,1-.28.61,3.35,3.35,0,0,0-.61,1.31c0,.16,0,.23.22.19a.48.48,0,0,0,.55.21s.06,0,.08,0c.36.17.52.14.85-.18a1.13,1.13,0,0,0,.23-.26c.17-.25.44-.27.69-.34a1.89,1.89,0,0,0,.84-.34s.19-.16.28,0a2.66,2.66,0,0,1,.33.44,1.88,1.88,0,0,1,.16.65,4.4,4.4,0,0,0,.24,1.25,1.35,1.35,0,0,0,1.57.83,2.72,2.72,0,0,1,1.36,0l.26.12-.5-.05c-.09,0-.13,0-.17.11-.24.57-.47,1.14-.75,1.68-.18.36-.44.67-.65,1s-.31.44-.16.68a1.17,1.17,0,0,0,.94.67l.7,0a1.09,1.09,0,0,0,.81-.6.39.39,0,0,0-.1-.39.34.34,0,0,1-.35.22.77.77,0,0,0-.23.1c0-.15.15-.15.27-.19l0-.3s-.07,0-.08,0c-.14.2-.22.23-.46.15l-.18-.05c-.21-.07-.24,0-.26.15s0,.09,0,.16a.42.42,0,0,1,0-.54c.26-.32.52-.64.8-.93a10.5,10.5,0,0,0,1.61-2.15,1.14,1.14,0,0,0,.15-.4.78.78,0,0,0-.37-.81,6.83,6.83,0,0,0-1-.58.66.66,0,0,1-.41-.8l.08.26c.08.24.31.32.5.42s.64.31.94.48a1,1,0,0,1,.31,1.52c-.18.26-.33.53-.5.8-.06.1-.06.16.09.18.55.1,1.1.26,1.65.32a8.71,8.71,0,0,0,1.35,0A14.75,14.75,0,0,0,51,52.94a3.73,3.73,0,0,1,1.45-.08l.1,0-.09-.77-.06-.64a5.11,5.11,0,0,0-.51-2.1c-.06-.11-.14-.21-.22-.33a1.33,1.33,0,0,1,.48.43,2.38,2.38,0,0,1,.38,1c.12.62.2,1.26.31,1.89a7.14,7.14,0,0,0,.57,2,3.62,3.62,0,0,0,1.29,1.48c.62.39,1.28.72,1.94,1s1.11.51,1.67.74,1.42.54,2.12.8l1,.37a.65.65,0,0,1,.41.4l-.56-.29,0,0c.06.2.13.39.17.59.1.53.2,1.07.29,1.6s.14.84.2,1.25c0,.23,0,.47,0,.7a1.45,1.45,0,0,0,.32,1l.22.2a7,7,0,0,1,1.19,1.47,1.09,1.09,0,0,0,.42.38h.33a.25.25,0,0,0,0-.09.4.4,0,0,1,0-.53,1.69,1.69,0,0,0,.15-.37c0-.23-.11-.38-.22-.55a2.09,2.09,0,0,0-.14-.17l-.27.37-.05,0a.62.62,0,0,0,.1-.73,1.17,1.17,0,0,0-.46-.63,1.12,1.12,0,0,1-.53-.92c-.08-.48-.12-1-.17-1.45a4.75,4.75,0,0,1-.06-.84c0-.4.08-.81.11-1.21a.9.9,0,0,0-.24-.66,6.07,6.07,0,0,0-1.12-.84c-.71-.49-1.42-1-2.1-1.51a9.57,9.57,0,0,1-2.29-2.62,3,3,0,0,1-.39-1.18,1.94,1.94,0,0,1,.13-1A4.15,4.15,0,0,0,57,52.86c.37-.09.7-.23.76-.64a2.57,2.57,0,0,0,0-.73c0-.23.08-.36.31-.31a1.16,1.16,0,0,1,.7.54c.57.84,1.11,1.7,1.66,2.55.33.51.65,1,1,1.55.47.68.94,1.35,1.43,2a11.88,11.88,0,0,0,.87,1c.27.29.56.57.84.85a10.53,10.53,0,0,0,1.85,1.39A10.11,10.11,0,0,0,69,62.23a16.3,16.3,0,0,0,2,.43,9,9,0,0,0,1.64.1,12.72,12.72,0,0,0,1.74-.21A9.81,9.81,0,0,0,77,61.66a12.31,12.31,0,0,0,1.16-.7.12.12,0,0,0,.07-.07c0-.08,0-.17,0-.26s-.16-.05-.23,0-.4.16-.6.25a11.68,11.68,0,0,1-2.21.8,10.3,10.3,0,0,1-1.53.29A12.07,12.07,0,0,1,72,62a7.27,7.27,0,0,1-2.92-.83,8.85,8.85,0,0,1-2-1.37l-.65-.62a14.92,14.92,0,0,1-1.56-1.89,27.48,27.48,0,0,1-1.64-2.71l-1.1-2a19,19,0,0,0-1.78-2.8A11.8,11.8,0,0,0,59,48.22a8.06,8.06,0,0,0-3.9-1.89,11.87,11.87,0,0,0-1.44-.2c-.82,0-1.65-.08-2.48-.06a13.66,13.66,0,0,0-3.53.49,9.38,9.38,0,0,0-2.06,1,4.7,4.7,0,0,1-1.39.62,2.33,2.33,0,0,1-.38,0,7.49,7.49,0,0,0-.82,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.9,37.3h-.55v1.57H132V37.3h-.55V37h1.43Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.93,37v1.89h-.33V37.53l-.62,1-.62-1v1.34H133V37h.35l.59.91.59-.91Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.1,41.88v.6A4.18,4.18,0,0,0,82,41.91a4,4,0,0,0-1.39-.23A4.15,4.15,0,0,0,79,42a4,4,0,0,0-1.29.86,4.15,4.15,0,0,0-.85,1.28,4.21,4.21,0,0,0,0,3.12,4.1,4.1,0,0,0,.85,1.27,3.89,3.89,0,0,0,1.29.86,4.15,4.15,0,0,0,1.63.31h.16a4.46,4.46,0,0,0,1.64-.3V47.22h0a2.29,2.29,0,0,1-.75.48,2.37,2.37,0,0,1-.88.16,2.43,2.43,0,0,1-.38,0h0a3.18,3.18,0,0,1-.51-.13,2.29,2.29,0,0,1-.75-.48,2.08,2.08,0,0,1-.67-1.54,2.1,2.1,0,0,1,.67-1.55,2.43,2.43,0,0,1,1.64-.64,2.31,2.31,0,0,1,1.63.64,2.07,2.07,0,0,1,.67,1.55v4H85V41.88Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75,49.69l-4.26-4.1v4.1H68.79V38.87h1.92V43L75,38.88h2.72l-5.62,5.39,5.62,5.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90,41.68a3.48,3.48,0,0,1,1.43.28,3.29,3.29,0,0,1,1.09.78,3.53,3.53,0,0,1,.71,1.14,4.08,4.08,0,0,1,.25,1.4v4.41H91.58V45.28A1.65,1.65,0,0,0,91,44a1.95,1.95,0,0,0-2.65,0,1.69,1.69,0,0,0-.54,1.26v4.41H85.91v-7.8h1.92v.58a3.94,3.94,0,0,1,1-.57A3.11,3.11,0,0,1,90,41.68Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.07,41.89a3.49,3.49,0,0,1,1.29-.23v1.83a2.25,2.25,0,0,0-1.63.64,2.11,2.11,0,0,0-.68,1.55v4h-1.92V41.88h1.92v.59A4.23,4.23,0,0,1,116.07,41.89Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.71,41.68a4.36,4.36,0,0,1,1.65.31,4.16,4.16,0,0,1,1.34.86,4,4,0,0,1,.91,1.28,3.85,3.85,0,0,1,0,3.12,4,4,0,0,1-.91,1.27,4,4,0,0,1-1.34.86,4.36,4.36,0,0,1-1.65.31,4.29,4.29,0,0,1-1.65-.31,4.15,4.15,0,0,1-1.35-.86,4.08,4.08,0,0,1-.9-1.27,3.85,3.85,0,0,1,0-3.12,4.12,4.12,0,0,1,.9-1.28,4.32,4.32,0,0,1,3-1.17Zm0,1.82a2.33,2.33,0,0,0-1.64.64,2.1,2.1,0,0,0-.67,1.55,2.08,2.08,0,0,0,.67,1.54,2.29,2.29,0,0,0,.75.48,2.42,2.42,0,0,0,.89.16,2.37,2.37,0,0,0,.88-.16,2.29,2.29,0,0,0,.75-.48,2,2,0,0,0,.67-1.54,2.07,2.07,0,0,0-.67-1.55A2.38,2.38,0,0,0,121.71,43.5Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.7,41.68a4.29,4.29,0,0,1,1.65.31,4.16,4.16,0,0,1,1.34.86,4,4,0,0,1,.91,1.28,3.85,3.85,0,0,1,0,3.12,4,4,0,0,1-.91,1.27,4,4,0,0,1-1.34.86,4.55,4.55,0,0,1-3.3,0,4,4,0,0,1-1.34-.86,4,4,0,0,1-.91-1.27,3.85,3.85,0,0,1,0-3.12,4,4,0,0,1,.91-1.28,4.16,4.16,0,0,1,1.34-.86A4.29,4.29,0,0,1,130.7,41.68Zm0,1.82a2.29,2.29,0,0,0-1.63.64,2.08,2.08,0,0,0-.68,1.55,2.06,2.06,0,0,0,.68,1.54,2.15,2.15,0,0,0,.74.48,2.42,2.42,0,0,0,.89.16,2.37,2.37,0,0,0,.88-.16,2.29,2.29,0,0,0,.75-.48,2.06,2.06,0,0,0,.68-1.54,2.08,2.08,0,0,0-.68-1.55A2.38,2.38,0,0,0,130.7,43.5Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.15,41.88v.6a4.25,4.25,0,0,0-1.08-.57,4,4,0,0,0-1.39-.23,4.15,4.15,0,0,0-1.63.31,3.9,3.9,0,0,0-1.28.86,3.82,3.82,0,0,0-.85,1.28,4.08,4.08,0,0,0,0,3.12,4,4,0,0,0,2.13,2.13,4.15,4.15,0,0,0,1.63.31h.16a4.46,4.46,0,0,0,1.64-.3V47.22h0a2.29,2.29,0,0,1-.75.48,2.37,2.37,0,0,1-.88.16,2.22,2.22,0,0,1-.37,0h0a3,3,0,0,1-.52-.13,2.15,2.15,0,0,1-.74-.48,2.06,2.06,0,0,1-.68-1.54,2.08,2.08,0,0,1,.68-1.55,2.28,2.28,0,0,1,.74-.47,2.47,2.47,0,0,1,.89-.17,2.29,2.29,0,0,1,1.63.64,2.08,2.08,0,0,1,.68,1.55v4h1.92V41.88Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.83,41.88h0v.59a4.36,4.36,0,0,0-1.07-.57,3.78,3.78,0,0,0-.7-.18,5.22,5.22,0,0,0-.82-.07,4,4,0,0,0-1.6.32,3.63,3.63,0,0,0-1.25.86,4,4,0,0,0-.8,1.27,4.1,4.1,0,0,0-.29,1.57h0a3.92,3.92,0,0,0,1.15,2.83,3.7,3.7,0,0,0,1.29.86,4.15,4.15,0,0,0,1.63.31h.28a4.29,4.29,0,0,0,1.52-.3V47.22h0a2.52,2.52,0,0,1-.75.48,2.37,2.37,0,0,1-.88.16,2.43,2.43,0,0,1-.38,0h0a2.93,2.93,0,0,1-.51-.13,2.19,2.19,0,0,1-.75-.48,2.07,2.07,0,0,1-.67-1.54,2,2,0,0,1,.16-.81l0-.06a2.22,2.22,0,0,1,.48-.68,2.32,2.32,0,0,1,.75-.47,2.43,2.43,0,0,1,.89-.17,2.31,2.31,0,0,1,1.63.64,2.45,2.45,0,0,1,.49.68.14.14,0,0,1,0,.06,2,2,0,0,1,.16.81v3.05a2,2,0,0,1-.67,1.53,2.21,2.21,0,0,1-1.63.66,2.17,2.17,0,0,1-1.16-.31L96,51.93a4.19,4.19,0,0,0,2.55.82,4.18,4.18,0,0,0,1.65-.32,4.34,4.34,0,0,0,1.34-.86,4.27,4.27,0,0,0,.91-1.28,3.91,3.91,0,0,0,.32-1.55V41.89h-1.92Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71,56.31v.51H68.79V53.91h2.14v.51H69.36v.74h1.32v.49H69.36v.66Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.7,53.67v3.11h-.57v-.14a1.29,1.29,0,0,1-.65.18,1.16,1.16,0,0,1,0-2.32,1.31,1.31,0,0,1,.65.17v-1Zm-.57,2.43v-.9a.89.89,0,0,0-.55-.19.64.64,0,0,0-.67.65.63.63,0,0,0,.67.64A.86.86,0,0,0,74.13,56.1Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.37,54.54v2.24H77.8v-.14a1.12,1.12,0,0,1-.61.18c-.66,0-1-.31-1-1V54.54h.57v1.25a.44.44,0,0,0,.49.51.74.74,0,0,0,.51-.18V54.54Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.9,56.37a1.09,1.09,0,0,1-.86.45,1.16,1.16,0,1,1,0-2.32,1.08,1.08,0,0,1,.87.45l-.37.34A.62.62,0,0,0,81,55a.64.64,0,1,0,0,1.28.62.62,0,0,0,.5-.27Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.58,54.54v2.24H85v-.16a1.22,1.22,0,0,1-.66.2,1.16,1.16,0,0,1,0-2.32,1.33,1.33,0,0,1,.66.18v-.14Zm-.57.67a.86.86,0,0,0-.56-.19.64.64,0,1,0,0,1.28.86.86,0,0,0,.56-.19Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.83,55v.79c0,.4.07.52.36.52l.26,0v.43a1.75,1.75,0,0,1-.52.08.65.65,0,0,1-.68-.71V55h-.32v-.48h.32v-.87h.58v.87h.63V55Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.83,54a.34.34,0,0,1,.33-.34.34.34,0,0,1,0,.67A.33.33,0,0,1,89.83,54Zm0,.58h.58v2.24h-.58Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.35,55.66a1.23,1.23,0,1,1-1.22-1.16A1.19,1.19,0,0,1,94.35,55.66Zm-.56,0a.66.66,0,1,0-.66.64A.66.66,0,0,0,93.79,55.66Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.93,55.57v1.25h-.58V55.57c0-.35-.17-.52-.48-.52a.74.74,0,0,0-.5.18v1.59H95.8V54.58h.57v.14a1,1,0,0,1,.6-.18C97.62,54.54,97.93,54.84,97.93,55.57Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.43,54.42v1h1.39V56h-1.39v.85h-.57V53.91h2.19v.51Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.75,55.66a1.23,1.23,0,1,1-1.22-1.16A1.19,1.19,0,0,1,107.75,55.66Zm-.56,0a.66.66,0,1,0-.66.64A.66.66,0,0,0,107.19,55.66Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.32,54.54v2.24h-.58v-.14a1.12,1.12,0,0,1-.61.18c-.66,0-1-.31-1-1V54.54h.58v1.25c0,.34.17.51.48.51a.72.72,0,0,0,.51-.18V54.54Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115,55.57v1.25h-.58V55.57c0-.35-.17-.52-.48-.52a.74.74,0,0,0-.5.18v1.59h-.57V54.58h.57v.14a1,1,0,0,1,.6-.18C114.7,54.54,115,54.84,115,55.57Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M118.79,53.67v3.11h-.58v-.14a1.29,1.29,0,0,1-.65.18,1.16,1.16,0,0,1,0-2.32,1.29,1.29,0,0,1,.65.17v-1Zm-.58,2.43v-.9a.89.89,0,0,0-.55-.19.65.65,0,0,0-.67.65.63.63,0,0,0,.67.64A.86.86,0,0,0,118.21,56.1Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.58,54.54v2.24H122v-.16a1.22,1.22,0,0,1-.66.2,1.16,1.16,0,0,1,0-2.32,1.33,1.33,0,0,1,.66.18v-.14Zm-.57.67a.85.85,0,0,0-.55-.19.64.64,0,1,0,0,1.28.85.85,0,0,0,.55-.19Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.83,55v.79c0,.4.07.52.36.52l.26,0v.43a1.67,1.67,0,0,1-.52.08.65.65,0,0,1-.68-.71V55h-.31v-.48h.31v-.87h.58v.87h.63V55Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.83,54a.33.33,0,1,1,.33.33A.34.34,0,0,1,126.83,54Zm0,.58h.57v2.24h-.57Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.35,55.66a1.23,1.23,0,1,1-1.22-1.16A1.19,1.19,0,0,1,131.35,55.66Zm-.56,0a.66.66,0,1,0-.66.64A.65.65,0,0,0,130.79,55.66Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.93,55.57v1.25h-.58V55.57c0-.35-.16-.52-.48-.52a.76.76,0,0,0-.5.18v1.59h-.57V54.58h.57v.14a1,1,0,0,1,.6-.18C134.63,54.54,134.93,54.84,134.93,55.57Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.34,61.94v.51H80.1V59.53h2.15V60H80.68v.75H82v.49H80.68v.66Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85,59.33v3.12h-.58v-.14a1.26,1.26,0,0,1-.65.18,1.17,1.17,0,0,1,0-2.33,1.36,1.36,0,0,1,.65.17v-1Zm-.58,2.44v-.9a.81.81,0,0,0-.55-.19.65.65,0,1,0,0,1.29A.82.82,0,0,0,84.42,61.77Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.65,60.2v2.25h-.58V62.3a1,1,0,0,1-.61.18c-.66,0-1-.3-1-1V60.2h.57v1.25c0,.35.17.52.49.52a.77.77,0,0,0,.51-.18V60.2Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.16,62a1.09,1.09,0,0,1-.87.45,1.16,1.16,0,1,1,0-2.32,1.05,1.05,0,0,1,.87.45l-.37.34a.62.62,0,0,0-.5-.27.65.65,0,1,0,0,1.29.61.61,0,0,0,.5-.28Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.81,60.2v2.25h-.57v-.17a1.14,1.14,0,0,1-.66.2,1.16,1.16,0,0,1,0-2.32,1.36,1.36,0,0,1,.66.18V60.2Zm-.57.67a.86.86,0,0,0-.56-.19.64.64,0,0,0-.67.64.65.65,0,0,0,.67.65.86.86,0,0,0,.56-.19Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94,60.68v.79c0,.4.07.52.36.52l.26,0v.43a1.33,1.33,0,0,1-.52.08.65.65,0,0,1-.68-.7v-1.1h-.31V60.2h.31v-.87H94v.87h.63v.48Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95,59.62a.34.34,0,0,1,.33-.34.34.34,0,0,1,.33.34.33.33,0,0,1-.33.34A.34.34,0,0,1,95,59.62Zm0,.58h.57v2.25h-.57Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.51,61.32a1.23,1.23,0,1,1-1.23-1.16A1.19,1.19,0,0,1,98.51,61.32Zm-.57,0a.65.65,0,0,0-.66-.64.65.65,0,1,0,0,1.29A.65.65,0,0,0,97.94,61.32Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.06,61.2v1.25h-.58V61.2c0-.35-.17-.52-.49-.52a.69.69,0,0,0-.49.18v1.59h-.58V60.2h.58v.14a1.06,1.06,0,0,1,.6-.18C100.76,60.16,101.06,60.47,101.06,61.2Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.4,61.15a6.1,6.1,0,0,1-.44.67l.35.34-.35.32-.32-.32a1.23,1.23,0,0,1-.78.32c-.67,0-1.1-.31-1.1-.85a.9.9,0,0,1,.61-.78.77.77,0,0,1-.25-.56.75.75,0,0,1,.82-.79.76.76,0,0,1,.83.73.9.9,0,0,1-.63.8l.5.47A2.89,2.89,0,0,0,105,61Zm-1.07.69-.65-.64c-.23.1-.34.24-.34.41s.2.41.55.41A.65.65,0,0,0,104.33,61.84Zm-.73-1.53a.6.6,0,0,0,.25.41c.19,0,.44-.19.44-.42a.35.35,0,0,0-.35-.38A.36.36,0,0,0,103.6,60.31Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.26,59.53h.64l-1.36,2.92h-.27l-1.36-2.92h.64l.85,1.91Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.16,59.62a.33.33,0,1,1,.66,0,.33.33,0,1,1-.66,0Zm0,.58h.58v2.25h-.58Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.41,61.84a1.8,1.8,0,0,0,.77.18c.27,0,.37-.1.37-.21s-.13-.19-.48-.26-.83-.27-.83-.7.33-.69.85-.69a2.21,2.21,0,0,1,.88.18l-.19.42a2.18,2.18,0,0,0-.7-.14c-.22,0-.33.08-.33.2s.14.18.5.26c.52.1.82.29.82.7s-.33.7-.9.7a2,2,0,0,1-1-.21Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.73,60.2v2.25h-.57v-.17a1.14,1.14,0,0,1-.66.2,1.16,1.16,0,0,1,0-2.32,1.33,1.33,0,0,1,.66.18V60.2Zm-.57.67a.86.86,0,0,0-.56-.19.63.63,0,0,0-.66.64.64.64,0,0,0,.66.65.86.86,0,0,0,.56-.19Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.83,61.59c0,.57-.45.9-1.13.9a2.27,2.27,0,0,1-1.21-.28l.22-.46a2,2,0,0,0,1,.22c.32,0,.51-.11.51-.33s-.19-.28-.62-.38c-.6-.14-1.08-.31-1.08-.88s.41-.88,1.07-.88a2.88,2.88,0,0,1,1.12.23l-.24.48a2.46,2.46,0,0,0-.89-.2c-.3,0-.46.13-.46.32s.21.29.64.39C119.4,60.86,119.83,61.06,119.83,61.59Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.73,61.49a.62.62,0,0,0,.64.5.71.71,0,0,0,.58-.28l.37.31a1.25,1.25,0,0,1-1,.46,1.16,1.16,0,0,1,0-2.32,1.08,1.08,0,0,1,1.09,1.2s0,.09,0,.13Zm0-.37h1.12a.49.49,0,0,0-.54-.5A.59.59,0,0,0,120.73,61.12Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.39,60.52a.85.85,0,0,1,.71-.36l.14,0v.62a1.86,1.86,0,0,0-.28,0,.54.54,0,0,0-.57.59v1.08h-.58V60.2h.58Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.85,60.2l-1.08,2.25h-.27l-1.08-2.25h.6l.62,1.28.61-1.28Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.15,59.62a.33.33,0,1,1,.65,0,.33.33,0,1,1-.65,0Zm0,.58h.58v2.25h-.58Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.29,62a1.07,1.07,0,0,1-.87.45,1.16,1.16,0,1,1,0-2.32,1.07,1.07,0,0,1,.88.45l-.37.34a.62.62,0,0,0-.51-.27.65.65,0,1,0,0,1.29.61.61,0,0,0,.51-.28Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.1,61.49a.62.62,0,0,0,.64.5.74.74,0,0,0,.58-.28l.37.31a1.25,1.25,0,0,1-1,.46,1.16,1.16,0,0,1,0-2.32,1.08,1.08,0,0,1,1.1,1.2s0,.09,0,.13Zm0-.37h1.12a.5.5,0,0,0-.55-.5A.59.59,0,0,0,131.1,61.12Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.27,61.84A1.8,1.8,0,0,0,134,62c.26,0,.37-.1.37-.21s-.13-.19-.48-.26-.84-.27-.84-.7.34-.69.86-.69a2.29,2.29,0,0,1,.88.18l-.19.42a2.18,2.18,0,0,0-.7-.14c-.22,0-.33.08-.33.2s.13.18.49.26c.53.1.83.29.83.7s-.33.7-.9.7a2,2,0,0,1-1-.21Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "156.19 249.57 131.38 208.24 106.58 249.57 156.19 249.57"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(21.54 105.19)"
  }, "Anil Uprety", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Chief Operating Officer"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 31
  }, "M: +61-450490383"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 40
  }, "E: anil@kangarooedu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 69.19,
    y: 40
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 70.87,
    y: 40
  }, "com"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 62
  }, "Suite 1001, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 36.52,
    y: 62
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.06,
    y: 62
  }, "evel 1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 58.35,
    y: 62
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.71,
    y: 62
  }, ", 307 Pitt "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 93.39,
    y: 62
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 97.66,
    y: 62
  }, "treet"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 71
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.35,
    y: 71
  }, "ydney NSW 200"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 58.18,
    y: 71
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 62.53,
    y: 71
  }, ", "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 66.2,
    y: 71
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 71.05,
    y: 71
  }, "ustralia"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 0,
    y: 80
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.9,
    y: 80
  }, ": +61-2-80605365"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 89
  }, "ww"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 11.01,
    y: 89
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.18,
    y: 89
  }, ".kangarooedu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 61.87,
    y: 89
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 63.55,
    y: 89
  }, "com")))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 0.28,
    y1: 195.72,
    x2: 156.19,
    y2: 195.72
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 0.28,
    y1: 139.02,
    x2: 156.19,
    y2: 139.02
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 0.28,
    y1: 82.33,
    x2: 156.19,
    y2: 82.33
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 0.28,
    y1: 25.64,
    x2: 156.19,
    y2: 25.64
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 0.28,
    y1: 224.06,
    x2: 156.19,
    y2: 224.06
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 0.28,
    y1: 167.37,
    x2: 156.19,
    y2: 167.37
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 0.28,
    y1: 110.68,
    x2: 156.19,
    y2: 110.68
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 0.28,
    y1: 53.98,
    x2: 156.19,
    y2: 53.98
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 106.58,
    y1: 249.57,
    x2: 106.58,
    y2: 0.13
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 49.89,
    y1: 249.57,
    x2: 49.89,
    y2: 0.13
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 134.93,
    y1: 249.57,
    x2: 134.93,
    y2: 0.13
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 78.24,
    y1: 249.57,
    x2: 78.24,
    y2: 0.13
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 21.54,
    y1: 249.57,
    x2: 21.54,
    y2: 0.13
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 0.28,
    y: 0.13,
    width: 155.91,
    height: 249.45
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 25.64,
    width: 0.78,
    height: 5.44
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 36.51,
    width: 0.78,
    height: 0.78
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 39.62,
    width: 0.78,
    height: 4.66
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 45.05,
    width: 0.78,
    height: 0.78
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 46.61,
    width: 0.78,
    height: 1.55
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 50.49,
    width: 0.78,
    height: 2.33
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 54.37,
    width: 0.78,
    height: 0.78
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 55.92,
    width: 0.78,
    height: 2.33
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 59.81,
    width: 0.78,
    height: 0.78
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 62.14,
    width: 0.78,
    height: 1.55
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 65.24,
    width: 0.78,
    height: 1.55
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 68.35,
    width: 0.78,
    height: 1.55
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 71.46,
    width: 0.78,
    height: 3.11
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 204.74,
    y: 76.89,
    width: 0.78,
    height: 5.44
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 33.4,
    width: 0.78,
    height: 2.33
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 36.51,
    width: 0.78,
    height: 0.78
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 38.84,
    width: 0.78,
    height: 0.78
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 45.83,
    width: 0.78,
    height: 1.55
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 48.16,
    width: 0.78,
    height: 4.66
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 54.37,
    width: 0.78,
    height: 3.11
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 59.03,
    width: 0.78,
    height: 3.11
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 67.57,
    width: 0.78,
    height: 1.55
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 71.46,
    width: 0.78,
    height: 1.55
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 73.79,
    width: 0.78,
    height: 0.78
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.51,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 27.19,
    width: 0.78,
    height: 2.33
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 31.85,
    width: 0.78,
    height: 1.55
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 34.18,
    width: 0.78,
    height: 1.55
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 36.51,
    width: 0.78,
    height: 1.55
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 38.84,
    width: 0.78,
    height: 3.11
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 45.05,
    width: 0.78,
    height: 2.33
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 49.71,
    width: 0.78,
    height: 1.55
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 52.82,
    width: 0.78,
    height: 1.55
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 55.92,
    width: 0.78,
    height: 0.78
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 57.48,
    width: 0.78,
    height: 3.11
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 61.36,
    width: 0.78,
    height: 0.78
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 65.24,
    width: 0.78,
    height: 1.55
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 69.13,
    width: 0.78,
    height: 2.33
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 72.23,
    width: 0.78,
    height: 1.55
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 78.45,
    width: 0.78,
    height: 2.33
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.29,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 27.19,
    width: 0.78,
    height: 2.33
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 34.96,
    width: 0.78,
    height: 5.44
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 44.28,
    width: 0.78,
    height: 1.55
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 46.61,
    width: 0.78,
    height: 1.55
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 48.94,
    width: 0.78,
    height: 3.88
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 54.37,
    width: 0.78,
    height: 0.78
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 56.7,
    width: 0.78,
    height: 3.11
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 60.58,
    width: 0.78,
    height: 0.78
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 62.14,
    width: 0.78,
    height: 3.88
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 72.23,
    width: 0.78,
    height: 3.11
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 78.45,
    width: 0.78,
    height: 2.33
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.07,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 27.19,
    width: 0.78,
    height: 2.33
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 34.96,
    width: 0.78,
    height: 0.78
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 38.06,
    width: 0.78,
    height: 2.33
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 42.72,
    width: 0.78,
    height: 0.78
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 44.28,
    width: 0.78,
    height: 4.66
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 49.71,
    width: 0.78,
    height: 0.78
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 52.82,
    width: 0.78,
    height: 0.78
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 59.03,
    width: 0.78,
    height: 5.44
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 67.57,
    width: 0.78,
    height: 1.55
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 69.9,
    width: 0.78,
    height: 0.78
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 73.01,
    width: 0.78,
    height: 0.78
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 74.56,
    width: 0.78,
    height: 1.55
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 78.45,
    width: 0.78,
    height: 2.33
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.84,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 33.4,
    width: 0.78,
    height: 2.33
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 37.29,
    width: 0.78,
    height: 0.78
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 39.62,
    width: 0.78,
    height: 0.78
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 51.27,
    width: 0.78,
    height: 2.33
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 55.15,
    width: 0.78,
    height: 5.44
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 62.91,
    width: 0.78,
    height: 3.88
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 67.57,
    width: 0.78,
    height: 1.55
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 73.01,
    width: 0.78,
    height: 1.55
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.62,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 25.64,
    width: 0.78,
    height: 5.44
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 34.96,
    width: 0.78,
    height: 0.78
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 36.51,
    width: 0.78,
    height: 0.78
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 38.06,
    width: 0.78,
    height: 0.78
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 39.62,
    width: 0.78,
    height: 0.78
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 42.72,
    width: 0.78,
    height: 0.78
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 45.83,
    width: 0.78,
    height: 0.78
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 52.04,
    width: 0.78,
    height: 0.78
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 53.6,
    width: 0.78,
    height: 0.78
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 55.15,
    width: 0.78,
    height: 0.78
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 58.25,
    width: 0.78,
    height: 0.78
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 59.81,
    width: 0.78,
    height: 0.78
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 61.36,
    width: 0.78,
    height: 0.78
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 67.57,
    width: 0.78,
    height: 0.78
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 72.23,
    width: 0.78,
    height: 0.78
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 73.79,
    width: 0.78,
    height: 0.78
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 209.4,
    y: 76.89,
    width: 0.78,
    height: 5.44
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.17,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.17,
    y: 36.51,
    width: 0.78,
    height: 6.21
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.17,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.17,
    y: 47.38,
    width: 0.78,
    height: 4.66
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.17,
    y: 53.6,
    width: 0.78,
    height: 3.88
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.17,
    y: 59.81,
    width: 0.78,
    height: 0.78
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.17,
    y: 62.91,
    width: 0.78,
    height: 4.66
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.17,
    y: 69.13,
    width: 0.78,
    height: 1.55
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.17,
    y: 71.46,
    width: 0.78,
    height: 0.78
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 27.19,
    width: 0.78,
    height: 4.66
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 33.4,
    width: 0.78,
    height: 3.11
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 38.06,
    width: 0.78,
    height: 1.55
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 44.28,
    width: 0.78,
    height: 4.66
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 49.71,
    width: 0.78,
    height: 1.55
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 52.82,
    width: 0.78,
    height: 6.21
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 59.81,
    width: 0.78,
    height: 6.21
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 67.57,
    width: 0.78,
    height: 0.78
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 70.68,
    width: 0.78,
    height: 3.11
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 74.56,
    width: 0.78,
    height: 2.33
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 77.67,
    width: 0.78,
    height: 3.11
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 210.95,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 26.41,
    width: 0.78,
    height: 1.55
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 35.73,
    width: 0.78,
    height: 0.78
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 38.06,
    width: 0.78,
    height: 0.78
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 39.62,
    width: 0.78,
    height: 0.78
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 42.72,
    width: 0.78,
    height: 0.78
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 45.05,
    width: 0.78,
    height: 0.78
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 46.61,
    width: 0.78,
    height: 0.78
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 52.82,
    width: 0.78,
    height: 3.11
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 59.03,
    width: 0.78,
    height: 0.78
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 61.36,
    width: 0.78,
    height: 2.33
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 71.46,
    width: 0.78,
    height: 0.78
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 73.79,
    width: 0.78,
    height: 2.33
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 77.67,
    width: 0.78,
    height: 0.78
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.73,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 26.41,
    width: 0.78,
    height: 2.33
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 29.52,
    width: 0.78,
    height: 1.55
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 34.96,
    width: 0.78,
    height: 1.55
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 37.29,
    width: 0.78,
    height: 0.78
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 38.84,
    width: 0.78,
    height: 3.88
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 43.5,
    width: 0.78,
    height: 0.78
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 45.05,
    width: 0.78,
    height: 0.78
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 48.94,
    width: 0.78,
    height: 3.11
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 53.6,
    width: 0.78,
    height: 0.78
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 55.15,
    width: 0.78,
    height: 2.33
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 59.03,
    width: 0.78,
    height: 0.78
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 60.58,
    width: 0.78,
    height: 0.78
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 66.8,
    width: 0.78,
    height: 0.78
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 73.79,
    width: 0.78,
    height: 0.78
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 76.89,
    width: 0.78,
    height: 2.33
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.5,
    y: 80,
    width: 0.78,
    height: 0.78
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 26.41,
    width: 0.78,
    height: 0.78
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 31.85,
    width: 0.78,
    height: 2.33
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 34.96,
    width: 0.78,
    height: 0.78
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 36.51,
    width: 0.78,
    height: 0.78
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 48.16,
    width: 0.78,
    height: 3.88
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 52.82,
    width: 0.78,
    height: 3.11
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 58.25,
    width: 0.78,
    height: 1.55
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 61.36,
    width: 0.78,
    height: 1.55
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 70.68,
    width: 0.78,
    height: 2.33
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 73.79,
    width: 0.78,
    height: 0.78
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 213.28,
    y: 76.89,
    width: 0.78,
    height: 1.55
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 25.64,
    width: 0.78,
    height: 1.55
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 30.3,
    width: 0.78,
    height: 1.55
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 33.4,
    width: 0.78,
    height: 1.55
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 36.51,
    width: 0.78,
    height: 1.55
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 42.72,
    width: 0.78,
    height: 1.55
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 45.05,
    width: 0.78,
    height: 2.33
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 52.04,
    width: 0.78,
    height: 0.78
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 55.92,
    width: 0.78,
    height: 1.55
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 59.03,
    width: 0.78,
    height: 1.55
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 64.47,
    width: 0.78,
    height: 1.55
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 70.68,
    width: 0.78,
    height: 1.55
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 76.89,
    width: 0.78,
    height: 1.55
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.06,
    y: 80,
    width: 0.78,
    height: 0.78
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 29.52,
    width: 0.78,
    height: 0.78
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 32.63,
    width: 0.78,
    height: 0.78
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 34.18,
    width: 0.78,
    height: 0.78
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 35.73,
    width: 0.78,
    height: 3.11
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 39.62,
    width: 0.78,
    height: 0.78
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 41.17,
    width: 0.78,
    height: 3.88
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 52.04,
    width: 0.78,
    height: 0.78
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 53.6,
    width: 0.78,
    height: 0.78
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 55.15,
    width: 0.78,
    height: 1.55
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 57.48,
    width: 0.78,
    height: 0.78
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 59.03,
    width: 0.78,
    height: 3.11
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 63.69,
    width: 0.78,
    height: 0.78
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 65.24,
    width: 0.78,
    height: 3.11
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 69.9,
    width: 0.78,
    height: 0.78
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 71.46,
    width: 0.78,
    height: 0.78
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 73.79,
    width: 0.78,
    height: 0.78
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 214.83,
    y: 80,
    width: 0.78,
    height: 2.33
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 25.64,
    width: 0.78,
    height: 1.55
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 28.74,
    width: 0.78,
    height: 2.33
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 31.85,
    width: 0.78,
    height: 3.88
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 38.06,
    width: 0.78,
    height: 2.33
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 41.17,
    width: 0.78,
    height: 1.55
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 43.5,
    width: 0.78,
    height: 2.33
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 50.49,
    width: 0.78,
    height: 1.55
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 52.82,
    width: 0.78,
    height: 0.78
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 54.37,
    width: 0.78,
    height: 0.78
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 55.92,
    width: 0.78,
    height: 0.78
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 57.48,
    width: 0.78,
    height: 0.78
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 59.03,
    width: 0.78,
    height: 0.78
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 60.58,
    width: 0.78,
    height: 1.55
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 66.8,
    width: 0.78,
    height: 1.55
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 69.9,
    width: 0.78,
    height: 3.11
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 73.79,
    width: 0.78,
    height: 0.78
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 215.61,
    y: 80.78,
    width: 0.78,
    height: 1.55
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 25.64,
    width: 0.78,
    height: 1.55
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 27.97,
    width: 0.78,
    height: 1.55
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 31.07,
    width: 0.78,
    height: 4.66
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 37.29,
    width: 0.78,
    height: 2.33
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 40.39,
    width: 0.78,
    height: 0.78
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 45.05,
    width: 0.78,
    height: 0.78
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 46.61,
    width: 0.78,
    height: 2.33
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 49.71,
    width: 0.78,
    height: 1.55
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 52.82,
    width: 0.78,
    height: 1.55
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 55.92,
    width: 0.78,
    height: 0.78
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 59.03,
    width: 0.78,
    height: 0.78
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 60.58,
    width: 0.78,
    height: 0.78
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 62.14,
    width: 0.78,
    height: 0.78
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 66.8,
    width: 0.78,
    height: 1.55
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 73.01,
    width: 0.78,
    height: 1.55
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 76.12,
    width: 0.78,
    height: 1.55
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 78.45,
    width: 0.78,
    height: 2.33
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.39,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 25.64,
    width: 0.78,
    height: 1.55
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 27.97,
    width: 0.78,
    height: 0.78
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 30.3,
    width: 0.78,
    height: 2.33
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 34.96,
    width: 0.78,
    height: 0.78
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 38.84,
    width: 0.78,
    height: 1.55
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 41.95,
    width: 0.78,
    height: 1.55
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 46.61,
    width: 0.78,
    height: 1.55
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 48.94,
    width: 0.78,
    height: 3.11
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 52.82,
    width: 0.78,
    height: 0.78
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 54.37,
    width: 0.78,
    height: 1.55
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 56.7,
    width: 0.78,
    height: 1.55
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 60.58,
    width: 0.78,
    height: 0.78
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 62.14,
    width: 0.78,
    height: 2.33
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 65.24,
    width: 0.78,
    height: 0.78
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 66.8,
    width: 0.78,
    height: 0.78
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 68.35,
    width: 0.78,
    height: 0.78
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 69.9,
    width: 0.78,
    height: 0.78
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 73.01,
    width: 0.78,
    height: 0.78
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 74.56,
    width: 0.78,
    height: 1.55
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.16,
    y: 79.22,
    width: 0.78,
    height: 3.11
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 25.64,
    width: 0.78,
    height: 3.11
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 31.07,
    width: 0.78,
    height: 0.78
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 32.63,
    width: 0.78,
    height: 1.55
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 34.96,
    width: 0.78,
    height: 0.78
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 36.51,
    width: 0.78,
    height: 1.55
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 38.84,
    width: 0.78,
    height: 1.55
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 41.17,
    width: 0.78,
    height: 2.33
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 45.05,
    width: 0.78,
    height: 3.11
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 52.04,
    width: 0.78,
    height: 1.55
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 57.48,
    width: 0.78,
    height: 0.78
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 59.81,
    width: 0.78,
    height: 3.11
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 63.69,
    width: 0.78,
    height: 2.33
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 67.57,
    width: 0.78,
    height: 2.33
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 73.79,
    width: 0.78,
    height: 1.55
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 76.89,
    width: 0.78,
    height: 2.33
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 217.94,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 30.3,
    width: 0.78,
    height: 1.55
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 34.96,
    width: 0.78,
    height: 1.55
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 37.29,
    width: 0.78,
    height: 0.78
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 38.84,
    width: 0.78,
    height: 0.78
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 45.05,
    width: 0.78,
    height: 0.78
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 46.61,
    width: 0.78,
    height: 3.88
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 51.27,
    width: 0.78,
    height: 2.33
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 55.15,
    width: 0.78,
    height: 1.55
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 57.48,
    width: 0.78,
    height: 2.33
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 60.58,
    width: 0.78,
    height: 1.55
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 66.8,
    width: 0.78,
    height: 1.55
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 69.9,
    width: 0.78,
    height: 0.78
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 73.79,
    width: 0.78,
    height: 0.78
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 76.12,
    width: 0.78,
    height: 1.55
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.72,
    y: 80,
    width: 0.78,
    height: 1.55
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 26.41,
    width: 0.78,
    height: 1.55
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 29.52,
    width: 0.78,
    height: 0.78
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 35.73,
    width: 0.78,
    height: 1.55
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 38.06,
    width: 0.78,
    height: 3.11
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 47.38,
    width: 0.78,
    height: 2.33
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 51.27,
    width: 0.78,
    height: 2.33
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 54.37,
    width: 0.78,
    height: 2.33
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 58.25,
    width: 0.78,
    height: 0.78
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 59.81,
    width: 0.78,
    height: 2.33
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 64.47,
    width: 0.78,
    height: 2.33
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 67.57,
    width: 0.78,
    height: 0.78
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 71.46,
    width: 0.78,
    height: 2.33
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 75.34,
    width: 0.78,
    height: 1.55
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 77.67,
    width: 0.78,
    height: 1.55
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.49,
    y: 80.78,
    width: 0.78,
    height: 0.78
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 25.64,
    width: 0.78,
    height: 1.55
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 30.3,
    width: 0.78,
    height: 1.55
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 32.63,
    width: 0.78,
    height: 0.78
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 34.18,
    width: 0.78,
    height: 0.78
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 35.73,
    width: 0.78,
    height: 0.78
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 38.06,
    width: 0.78,
    height: 3.11
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 41.95,
    width: 0.78,
    height: 2.33
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 45.83,
    width: 0.78,
    height: 0.78
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 48.16,
    width: 0.78,
    height: 2.33
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 51.27,
    width: 0.78,
    height: 1.55
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 56.7,
    width: 0.78,
    height: 1.55
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 61.36,
    width: 0.78,
    height: 1.55
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 63.69,
    width: 0.78,
    height: 0.78
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 66.02,
    width: 0.78,
    height: 1.55
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 71.46,
    width: 0.78,
    height: 2.33
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 74.56,
    width: 0.78,
    height: 0.78
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 76.12,
    width: 0.78,
    height: 1.55
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 80,
    width: 0.78,
    height: 0.78
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.27,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 26.41,
    width: 0.78,
    height: 1.55
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 28.74,
    width: 0.78,
    height: 1.55
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 33.4,
    width: 0.78,
    height: 3.11
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 39.62,
    width: 0.78,
    height: 0.78
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 42.72,
    width: 0.78,
    height: 0.78
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 48.94,
    width: 0.78,
    height: 1.55
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 52.04,
    width: 0.78,
    height: 1.55
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 55.15,
    width: 0.78,
    height: 3.11
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 59.03,
    width: 0.78,
    height: 1.55
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 61.36,
    width: 0.78,
    height: 1.55
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 65.24,
    width: 0.78,
    height: 2.33
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 68.35,
    width: 0.78,
    height: 1.55
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 72.23,
    width: 0.78,
    height: 0.78
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 76.89,
    width: 0.78,
    height: 1.55
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.05,
    y: 79.22,
    width: 0.78,
    height: 0.78
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 26.41,
    width: 0.78,
    height: 2.33
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 30.3,
    width: 0.78,
    height: 5.44
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 37.29,
    width: 0.78,
    height: 0.78
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 39.62,
    width: 0.78,
    height: 0.78
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 42.72,
    width: 0.78,
    height: 0.78
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 44.28,
    width: 0.78,
    height: 1.55
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 48.94,
    width: 0.78,
    height: 3.88
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 55.15,
    width: 0.78,
    height: 0.78
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 57.48,
    width: 0.78,
    height: 0.78
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 60.58,
    width: 0.78,
    height: 0.78
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 62.14,
    width: 0.78,
    height: 1.55
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 66.8,
    width: 0.78,
    height: 3.88
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 71.46,
    width: 0.78,
    height: 0.78
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 73.01,
    width: 0.78,
    height: 3.11
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 79.22,
    width: 0.78,
    height: 0.78
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.82,
    y: 80.78,
    width: 0.78,
    height: 0.78
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 27.19,
    width: 0.78,
    height: 0.78
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 34.18,
    width: 0.78,
    height: 2.33
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 38.84,
    width: 0.78,
    height: 1.55
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 41.17,
    width: 0.78,
    height: 1.55
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 43.5,
    width: 0.78,
    height: 0.78
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 45.05,
    width: 0.78,
    height: 0.78
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 47.38,
    width: 0.78,
    height: 1.55
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 52.04,
    width: 0.78,
    height: 1.55
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 55.92,
    width: 0.78,
    height: 2.33
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 61.36,
    width: 0.78,
    height: 0.78
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 63.69,
    width: 0.78,
    height: 0.78
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 66.02,
    width: 0.78,
    height: 2.33
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 69.9,
    width: 0.78,
    height: 1.55
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 72.23,
    width: 0.78,
    height: 2.33
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 76.12,
    width: 0.78,
    height: 0.78
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 222.6,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 27.19,
    width: 0.78,
    height: 6.21
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 34.18,
    width: 0.78,
    height: 1.55
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 39.62,
    width: 0.78,
    height: 0.78
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 42.72,
    width: 0.78,
    height: 6.21
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 49.71,
    width: 0.78,
    height: 0.78
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 51.27,
    width: 0.78,
    height: 0.78
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 52.82,
    width: 0.78,
    height: 1.55
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 55.15,
    width: 0.78,
    height: 2.33
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 59.81,
    width: 0.78,
    height: 3.88
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 66.8,
    width: 0.78,
    height: 0.78
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 69.13,
    width: 0.78,
    height: 1.55
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 73.79,
    width: 0.78,
    height: 5.44
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.38,
    y: 80,
    width: 0.78,
    height: 1.55
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 26.41,
    width: 0.78,
    height: 0.78
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 27.97,
    width: 0.78,
    height: 1.55
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 33.4,
    width: 0.78,
    height: 1.55
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 37.29,
    width: 0.78,
    height: 3.11
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 41.17,
    width: 0.78,
    height: 2.33
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 47.38,
    width: 0.78,
    height: 2.33
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 50.49,
    width: 0.78,
    height: 1.55
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 55.92,
    width: 0.78,
    height: 0.78
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 57.48,
    width: 0.78,
    height: 3.11
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 64.47,
    width: 0.78,
    height: 3.11
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 68.35,
    width: 0.78,
    height: 0.78
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 69.9,
    width: 0.78,
    height: 2.33
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 73.01,
    width: 0.78,
    height: 3.11
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.15,
    y: 80,
    width: 0.78,
    height: 2.33
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 34.18,
    width: 0.78,
    height: 1.55
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 36.51,
    width: 0.78,
    height: 1.55
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 39.62,
    width: 0.78,
    height: 1.55
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 43.5,
    width: 0.78,
    height: 1.55
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 45.83,
    width: 0.78,
    height: 0.78
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 47.38,
    width: 0.78,
    height: 1.55
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 49.71,
    width: 0.78,
    height: 1.55
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 52.82,
    width: 0.78,
    height: 1.55
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 55.15,
    width: 0.78,
    height: 0.78
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 58.25,
    width: 0.78,
    height: 0.78
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 59.81,
    width: 0.78,
    height: 0.78
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 61.36,
    width: 0.78,
    height: 0.78
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 65.24,
    width: 0.78,
    height: 0.78
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 67.57,
    width: 0.78,
    height: 3.88
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 72.23,
    width: 0.78,
    height: 0.78
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.93,
    y: 80,
    width: 0.78,
    height: 0.78
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 27.19,
    width: 0.78,
    height: 0.78
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 31.85,
    width: 0.78,
    height: 1.55
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 34.18,
    width: 0.78,
    height: 0.78
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 40.39,
    width: 0.78,
    height: 3.11
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 48.94,
    width: 0.78,
    height: 1.55
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 51.27,
    width: 0.78,
    height: 1.55
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 53.6,
    width: 0.78,
    height: 2.33
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 57.48,
    width: 0.78,
    height: 1.55
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 59.81,
    width: 0.78,
    height: 0.78
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 66.8,
    width: 0.78,
    height: 0.78
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 68.35,
    width: 0.78,
    height: 1.55
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 70.68,
    width: 0.78,
    height: 1.55
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 73.01,
    width: 0.78,
    height: 0.78
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 74.56,
    width: 0.78,
    height: 1.55
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.71,
    y: 80.78,
    width: 0.78,
    height: 0.78
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 28.74,
    width: 0.78,
    height: 3.88
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 33.4,
    width: 0.78,
    height: 3.88
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 38.06,
    width: 0.78,
    height: 0.78
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 39.62,
    width: 0.78,
    height: 3.11
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 44.28,
    width: 0.78,
    height: 3.88
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 49.71,
    width: 0.78,
    height: 1.55
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 52.04,
    width: 0.78,
    height: 0.78
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 54.37,
    width: 0.78,
    height: 1.55
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 59.81,
    width: 0.78,
    height: 5.44
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 68.35,
    width: 0.78,
    height: 0.78
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 75.34,
    width: 0.78,
    height: 5.44
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 226.48,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 26.41,
    width: 0.78,
    height: 0.78
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 31.07,
    width: 0.78,
    height: 0.78
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 33.4,
    width: 0.78,
    height: 1.55
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 35.73,
    width: 0.78,
    height: 2.33
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 38.84,
    width: 0.78,
    height: 0.78
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 40.39,
    width: 0.78,
    height: 0.78
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 43.5,
    width: 0.78,
    height: 3.11
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 49.71,
    width: 0.78,
    height: 0.78
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 51.27,
    width: 0.78,
    height: 2.33
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 57.48,
    width: 0.78,
    height: 0.78
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 59.03,
    width: 0.78,
    height: 0.78
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 62.14,
    width: 0.78,
    height: 0.78
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 63.69,
    width: 0.78,
    height: 1.55
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 67.57,
    width: 0.78,
    height: 1.55
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 73.01,
    width: 0.78,
    height: 2.33
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 76.89,
    width: 0.78,
    height: 1.55
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 79.22,
    width: 0.78,
    height: 0.78
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.26,
    y: 80.78,
    width: 0.78,
    height: 0.78
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 26.41,
    width: 0.78,
    height: 0.78
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 29.52,
    width: 0.78,
    height: 1.55
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 35.73,
    width: 0.78,
    height: 1.55
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 39.62,
    width: 0.78,
    height: 3.11
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 43.5,
    width: 0.78,
    height: 0.78
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 45.05,
    width: 0.78,
    height: 2.33
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 49.71,
    width: 0.78,
    height: 1.55
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 64.47,
    width: 0.78,
    height: 5.44
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 72.23,
    width: 0.78,
    height: 3.88
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 76.89,
    width: 0.78,
    height: 1.55
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.04,
    y: 80,
    width: 0.78,
    height: 0.78
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 26.41,
    width: 0.78,
    height: 0.78
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 31.07,
    width: 0.78,
    height: 1.55
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 33.4,
    width: 0.78,
    height: 2.33
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 36.51,
    width: 0.78,
    height: 0.78
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 40.39,
    width: 0.78,
    height: 0.78
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 45.83,
    width: 0.78,
    height: 0.78
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 52.04,
    width: 0.78,
    height: 0.78
  })), _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 55.15,
    width: 0.78,
    height: 0.78
  })), _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 59.81,
    width: 0.78,
    height: 0.78
  })), _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 61.36,
    width: 0.78,
    height: 0.78
  })), _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 67.57,
    width: 0.78,
    height: 0.78
  })), _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 72.23,
    width: 0.78,
    height: 0.78
  })), _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 73.79,
    width: 0.78,
    height: 2.33
  })), _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 80.78,
    width: 0.78,
    height: 1.55
  })), _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 25.64,
    width: 0.78,
    height: 1.55
  })), _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 27.97,
    width: 0.78,
    height: 3.11
  })), _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 34.18,
    width: 0.78,
    height: 2.33
  })), _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 37.29,
    width: 0.78,
    height: 1.55
  })), _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 43.5,
    width: 0.78,
    height: 5.44
  })), _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 52.82,
    width: 0.78,
    height: 2.33
  })), _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 59.81,
    width: 0.78,
    height: 0.78
  })), _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 62.14,
    width: 0.78,
    height: 0.78
  })), _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 66.02,
    width: 0.78,
    height: 1.55
  })), _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 69.13,
    width: 0.78,
    height: 6.21
  })), _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 76.89,
    width: 0.78,
    height: 2.33
  })), _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 229.59,
    y: 80,
    width: 0.78,
    height: 1.55
  })), _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 25.64,
    width: 0.78,
    height: 4.66
  })), _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 31.07,
    width: 0.78,
    height: 2.33
  })), _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 34.18,
    width: 0.78,
    height: 1.55
  })), _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 38.06,
    width: 0.78,
    height: 0.78
  })), _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 39.62,
    width: 0.78,
    height: 0.78
  })), _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 42.72,
    width: 0.78,
    height: 0.78
  })), _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 45.83,
    width: 0.78,
    height: 0.78
  })), _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 47.38,
    width: 0.78,
    height: 1.55
  })), _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 52.04,
    width: 0.78,
    height: 3.88
  })), _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 58.25,
    width: 0.78,
    height: 3.11
  })), _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 64.47,
    width: 0.78,
    height: 1.55
  })), _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 66.8,
    width: 0.78,
    height: 0.78
  })), _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 69.13,
    width: 0.78,
    height: 1.55
  })), _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 71.46,
    width: 0.78,
    height: 3.11
  })), _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 76.89,
    width: 0.78,
    height: 3.88
  })), _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 230.37,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 28.74,
    width: 0.78,
    height: 2.33
  })), _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 31.85,
    width: 0.78,
    height: 1.55
  })), _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 34.18,
    width: 0.78,
    height: 0.78
  })), _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 36.51,
    width: 0.78,
    height: 3.11
  })), _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 41.17,
    width: 0.78,
    height: 2.33
  })), _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 44.28,
    width: 0.78,
    height: 2.33
  })), _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 48.16,
    width: 0.78,
    height: 0.78
  })), _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 49.71,
    width: 0.78,
    height: 1.55
  })), _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 52.82,
    width: 0.78,
    height: 0.78
  })), _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 54.37,
    width: 0.78,
    height: 1.55
  })), _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 56.7,
    width: 0.78,
    height: 2.33
  })), _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 59.81,
    width: 0.78,
    height: 1.55
  })), _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 63.69,
    width: 0.78,
    height: 1.55
  })), _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 69.13,
    width: 0.78,
    height: 1.55
  })), _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 72.23,
    width: 0.78,
    height: 0.78
  })), _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 77.67,
    width: 0.78,
    height: 0.78
  })), _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.14,
    y: 79.22,
    width: 0.78,
    height: 0.78
  })), _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 27.19,
    width: 0.78,
    height: 0.78
  })), _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 31.85,
    width: 0.78,
    height: 3.88
  })), _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 36.51,
    width: 0.78,
    height: 1.55
  })), _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 39.62,
    width: 0.78,
    height: 1.55
  })), _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 43.5,
    width: 0.78,
    height: 0.78
  })), _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 45.83,
    width: 0.78,
    height: 0.78
  })), _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 55.15,
    width: 0.78,
    height: 0.78
  })), _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 58.25,
    width: 0.78,
    height: 0.78
  })), _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 62.14,
    width: 0.78,
    height: 0.78
  })), _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 64.47,
    width: 0.78,
    height: 1.55
  })), _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 66.8,
    width: 0.78,
    height: 0.78
  })), _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 74.56,
    width: 0.78,
    height: 0.78
  })), _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.92,
    y: 80.78,
    width: 0.78,
    height: 0.78
  })), _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 26.41,
    width: 0.78,
    height: 2.33
  })), _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 29.52,
    width: 0.78,
    height: 4.66
  })), _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 36.51,
    width: 0.78,
    height: 7.77
  })), _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 45.05,
    width: 0.78,
    height: 2.33
  })), _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 49.71,
    width: 0.78,
    height: 2.33
  })), _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 52.82,
    width: 0.78,
    height: 0.78
  })), _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 54.37,
    width: 0.78,
    height: 3.11
  })), _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 60.58,
    width: 0.78,
    height: 2.33
  })), _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 67.57,
    width: 0.78,
    height: 1.55
  })), _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 74.56,
    width: 0.78,
    height: 0.78
  })), _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 79.22,
    width: 0.78,
    height: 0.78
  })), _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.7,
    y: 80.78,
    width: 0.78,
    height: 1.55
  })), _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 28.74,
    width: 0.78,
    height: 1.55
  })), _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 36.51,
    width: 0.78,
    height: 1.55
  })), _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 38.84,
    width: 0.78,
    height: 0.78
  })), _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 40.39,
    width: 0.78,
    height: 2.33
  })), _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 43.5,
    width: 0.78,
    height: 0.78
  })), _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 45.83,
    width: 0.78,
    height: 1.55
  })), _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 48.16,
    width: 0.78,
    height: 1.55
  })), _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 50.49,
    width: 0.78,
    height: 1.55
  })), _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 53.6,
    width: 0.78,
    height: 0.78
  })), _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 57.48,
    width: 0.78,
    height: 0.78
  })), _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 59.03,
    width: 0.78,
    height: 0.78
  })), _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 62.14,
    width: 0.78,
    height: 0.78
  })), _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 67.57,
    width: 0.78,
    height: 2.33
  })), _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 70.68,
    width: 0.78,
    height: 3.11
  })), _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 74.56,
    width: 0.78,
    height: 1.55
  })), _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.47,
    y: 78.45,
    width: 0.78,
    height: 2.33
  })), _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 34.18,
    width: 0.78,
    height: 1.55
  })), _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 37.29,
    width: 0.78,
    height: 2.33
  })), _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 49.71,
    width: 0.78,
    height: 0.78
  })), _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 51.27,
    width: 0.78,
    height: 1.55
  })), _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 55.15,
    width: 0.78,
    height: 0.78
  })), _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 56.7,
    width: 0.78,
    height: 2.33
  })), _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 60.58,
    width: 0.78,
    height: 0.78
  })), _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 63.69,
    width: 0.78,
    height: 1.55
  })), _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 69.13,
    width: 0.78,
    height: 1.55
  })), _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 72.23,
    width: 0.78,
    height: 0.78
  })), _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 80,
    width: 0.78,
    height: 0.78
  })), _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.25,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 25.64,
    width: 0.78,
    height: 4.66
  })), _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 31.85,
    width: 0.78,
    height: 1.55
  })), _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 34.96,
    width: 0.78,
    height: 1.55
  })), _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 38.84,
    width: 0.78,
    height: 0.78
  })), _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 42.72,
    width: 0.78,
    height: 0.78
  })), _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 45.05,
    width: 0.78,
    height: 0.78
  })), _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 46.61,
    width: 0.78,
    height: 0.78
  })), _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 48.16,
    width: 0.78,
    height: 9.32
  })), _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 58.25,
    width: 0.78,
    height: 0.78
  })), _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 59.81,
    width: 0.78,
    height: 1.55
  })), _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 65.24,
    width: 0.78,
    height: 1.55
  })), _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 68.35,
    width: 0.78,
    height: 0.78
  })), _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 69.9,
    width: 0.78,
    height: 0.78
  })), _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 73.01,
    width: 0.78,
    height: 0.78
  })), _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 76.12,
    width: 0.78,
    height: 2.33
  })), _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.03,
    y: 79.22,
    width: 0.78,
    height: 0.78
  })), _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 26.41,
    width: 0.78,
    height: 2.33
  })), _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 29.52,
    width: 0.78,
    height: 2.33
  })), _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 32.63,
    width: 0.78,
    height: 0.78
  })), _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 34.18,
    width: 0.78,
    height: 0.78
  })), _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 35.73,
    width: 0.78,
    height: 0.78
  })), _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 38.84,
    width: 0.78,
    height: 0.78
  })), _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 44.28,
    width: 0.78,
    height: 2.33
  })), _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 47.38,
    width: 0.78,
    height: 1.55
  })), _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 49.71,
    width: 0.78,
    height: 1.55
  })), _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 52.82,
    width: 0.78,
    height: 0.78
  })), _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 55.15,
    width: 0.78,
    height: 1.55
  })), _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 59.81,
    width: 0.78,
    height: 1.55
  })), _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 63.69,
    width: 0.78,
    height: 0.78
  })), _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 65.24,
    width: 0.78,
    height: 0.78
  })), _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 66.8,
    width: 0.78,
    height: 0.78
  })), _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 69.13,
    width: 0.78,
    height: 2.33
  })), _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 72.23,
    width: 0.78,
    height: 1.55
  })), _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect767 || (_rect767 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.8,
    y: 79.22,
    width: 0.78,
    height: 1.55
  })), _rect768 || (_rect768 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect769 || (_rect769 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 27.19,
    width: 0.78,
    height: 0.78
  })), _rect770 || (_rect770 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect771 || (_rect771 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 31.07,
    width: 0.78,
    height: 0.78
  })), _rect772 || (_rect772 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 32.63,
    width: 0.78,
    height: 0.78
  })), _rect773 || (_rect773 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 35.73,
    width: 0.78,
    height: 2.33
  })), _rect774 || (_rect774 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 38.84,
    width: 0.78,
    height: 0.78
  })), _rect775 || (_rect775 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 40.39,
    width: 0.78,
    height: 3.88
  })), _rect776 || (_rect776 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 45.05,
    width: 0.78,
    height: 3.11
  })), _rect777 || (_rect777 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect778 || (_rect778 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 52.04,
    width: 0.78,
    height: 0.78
  })), _rect779 || (_rect779 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 53.6,
    width: 0.78,
    height: 0.78
  })), _rect780 || (_rect780 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 57.48,
    width: 0.78,
    height: 0.78
  })), _rect781 || (_rect781 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 60.58,
    width: 0.78,
    height: 2.33
  })), _rect782 || (_rect782 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 63.69,
    width: 0.78,
    height: 0.78
  })), _rect783 || (_rect783 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect784 || (_rect784 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 67.57,
    width: 0.78,
    height: 2.33
  })), _rect785 || (_rect785 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 71.46,
    width: 0.78,
    height: 0.78
  })), _rect786 || (_rect786 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 73.01,
    width: 0.78,
    height: 0.78
  })), _rect787 || (_rect787 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 74.56,
    width: 0.78,
    height: 2.33
  })), _rect788 || (_rect788 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 236.58,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect789 || (_rect789 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 26.41,
    width: 0.78,
    height: 1.55
  })), _rect790 || (_rect790 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect791 || (_rect791 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 30.3,
    width: 0.78,
    height: 2.33
  })), _rect792 || (_rect792 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect793 || (_rect793 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 35.73,
    width: 0.78,
    height: 1.55
  })), _rect794 || (_rect794 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 39.62,
    width: 0.78,
    height: 7.77
  })), _rect795 || (_rect795 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 48.16,
    width: 0.78,
    height: 0.78
  })), _rect796 || (_rect796 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 49.71,
    width: 0.78,
    height: 0.78
  })), _rect797 || (_rect797 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 53.6,
    width: 0.78,
    height: 0.78
  })), _rect798 || (_rect798 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 55.15,
    width: 0.78,
    height: 3.11
  })), _rect799 || (_rect799 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 59.03,
    width: 0.78,
    height: 0.78
  })), _rect800 || (_rect800 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 61.36,
    width: 0.78,
    height: 0.78
  })), _rect801 || (_rect801 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect802 || (_rect802 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 64.47,
    width: 0.78,
    height: 4.66
  })), _rect803 || (_rect803 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 69.9,
    width: 0.78,
    height: 2.33
  })), _rect804 || (_rect804 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 73.01,
    width: 0.78,
    height: 2.33
  })), _rect805 || (_rect805 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 76.12,
    width: 0.78,
    height: 0.78
  })), _rect806 || (_rect806 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 77.67,
    width: 0.78,
    height: 0.78
  })), _rect807 || (_rect807 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.36,
    y: 79.22,
    width: 0.78,
    height: 2.33
  })), _rect808 || (_rect808 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 27.97,
    width: 0.78,
    height: 0.78
  })), _rect809 || (_rect809 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 31.07,
    width: 0.78,
    height: 0.78
  })), _rect810 || (_rect810 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 32.63,
    width: 0.78,
    height: 1.55
  })), _rect811 || (_rect811 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 34.96,
    width: 0.78,
    height: 0.78
  })), _rect812 || (_rect812 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 40.39,
    width: 0.78,
    height: 0.78
  })), _rect813 || (_rect813 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect814 || (_rect814 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 43.5,
    width: 0.78,
    height: 0.78
  })), _rect815 || (_rect815 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 46.61,
    width: 0.78,
    height: 2.33
  })), _rect816 || (_rect816 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 49.71,
    width: 0.78,
    height: 2.33
  })), _rect817 || (_rect817 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 52.82,
    width: 0.78,
    height: 1.55
  })), _rect818 || (_rect818 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 60.58,
    width: 0.78,
    height: 0.78
  })), _rect819 || (_rect819 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 63.69,
    width: 0.78,
    height: 1.55
  })), _rect820 || (_rect820 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 66.02,
    width: 0.78,
    height: 3.11
  })), _rect821 || (_rect821 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 69.9,
    width: 0.78,
    height: 0.78
  })), _rect822 || (_rect822 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 71.46,
    width: 0.78,
    height: 0.78
  })), _rect823 || (_rect823 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 73.01,
    width: 0.78,
    height: 0.78
  })), _rect824 || (_rect824 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 74.56,
    width: 0.78,
    height: 0.78
  })), _rect825 || (_rect825 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 76.12,
    width: 0.78,
    height: 2.33
  })), _rect826 || (_rect826 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.13,
    y: 80,
    width: 0.78,
    height: 2.33
  })), _rect827 || (_rect827 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 26.41,
    width: 0.78,
    height: 0.78
  })), _rect828 || (_rect828 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 27.97,
    width: 0.78,
    height: 4.66
  })), _rect829 || (_rect829 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 34.18,
    width: 0.78,
    height: 0.78
  })), _rect830 || (_rect830 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 37.29,
    width: 0.78,
    height: 0.78
  })), _rect831 || (_rect831 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 38.84,
    width: 0.78,
    height: 2.33
  })), _rect832 || (_rect832 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 44.28,
    width: 0.78,
    height: 3.88
  })), _rect833 || (_rect833 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect834 || (_rect834 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 53.6,
    width: 0.78,
    height: 0.78
  })), _rect835 || (_rect835 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 59.03,
    width: 0.78,
    height: 4.66
  })), _rect836 || (_rect836 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect837 || (_rect837 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 67.57,
    width: 0.78,
    height: 2.33
  })), _rect838 || (_rect838 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 70.68,
    width: 0.78,
    height: 1.55
  })), _rect839 || (_rect839 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.91,
    y: 74.56,
    width: 0.78,
    height: 5.44
  })), _rect840 || (_rect840 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 25.64,
    width: 0.78,
    height: 2.33
  })), _rect841 || (_rect841 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect842 || (_rect842 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect843 || (_rect843 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 33.4,
    width: 0.78,
    height: 1.55
  })), _rect844 || (_rect844 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 35.73,
    width: 0.78,
    height: 3.88
  })), _rect845 || (_rect845 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect846 || (_rect846 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect847 || (_rect847 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 48.94,
    width: 0.78,
    height: 5.44
  })), _rect848 || (_rect848 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 55.92,
    width: 0.78,
    height: 0.78
  })), _rect849 || (_rect849 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 59.03,
    width: 0.78,
    height: 1.55
  })), _rect850 || (_rect850 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect851 || (_rect851 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 64.47,
    width: 0.78,
    height: 5.44
  })), _rect852 || (_rect852 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 70.68,
    width: 0.78,
    height: 1.55
  })), _rect853 || (_rect853 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 73.01,
    width: 0.78,
    height: 3.11
  })), _rect854 || (_rect854 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.69,
    y: 78.45,
    width: 0.78,
    height: 1.55
  })), _rect855 || (_rect855 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 26.41,
    width: 0.78,
    height: 0.78
  })), _rect856 || (_rect856 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect857 || (_rect857 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect858 || (_rect858 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect859 || (_rect859 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 38.84,
    width: 0.78,
    height: 1.55
  })), _rect860 || (_rect860 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect861 || (_rect861 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 43.5,
    width: 0.78,
    height: 1.55
  })), _rect862 || (_rect862 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 45.83,
    width: 0.78,
    height: 0.78
  })), _rect863 || (_rect863 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect864 || (_rect864 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect865 || (_rect865 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 51.27,
    width: 0.78,
    height: 0.78
  })), _rect866 || (_rect866 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 52.82,
    width: 0.78,
    height: 0.78
  })), _rect867 || (_rect867 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect868 || (_rect868 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 58.25,
    width: 0.78,
    height: 2.33
  })), _rect869 || (_rect869 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 61.36,
    width: 0.78,
    height: 0.78
  })), _rect870 || (_rect870 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect871 || (_rect871 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 66.8,
    width: 0.78,
    height: 2.33
  })), _rect872 || (_rect872 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect873 || (_rect873 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 72.23,
    width: 0.78,
    height: 0.78
  })), _rect874 || (_rect874 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 74.56,
    width: 0.78,
    height: 1.55
  })), _rect875 || (_rect875 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect876 || (_rect876 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect877 || (_rect877 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 80,
    width: 0.78,
    height: 0.78
  })), _rect878 || (_rect878 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 240.46,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect879 || (_rect879 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 26.41,
    width: 0.78,
    height: 0.78
  })), _rect880 || (_rect880 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 27.97,
    width: 0.78,
    height: 1.55
  })), _rect881 || (_rect881 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect882 || (_rect882 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect883 || (_rect883 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 36.51,
    width: 0.78,
    height: 0.78
  })), _rect884 || (_rect884 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 38.84,
    width: 0.78,
    height: 2.33
  })), _rect885 || (_rect885 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 41.95,
    width: 0.78,
    height: 3.11
  })), _rect886 || (_rect886 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 47.38,
    width: 0.78,
    height: 3.11
  })), _rect887 || (_rect887 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 51.27,
    width: 0.78,
    height: 0.78
  })), _rect888 || (_rect888 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 52.82,
    width: 0.78,
    height: 0.78
  })), _rect889 || (_rect889 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 54.37,
    width: 0.78,
    height: 2.33
  })), _rect890 || (_rect890 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 57.48,
    width: 0.78,
    height: 0.78
  })), _rect891 || (_rect891 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 59.03,
    width: 0.78,
    height: 1.55
  })), _rect892 || (_rect892 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect893 || (_rect893 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect894 || (_rect894 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect895 || (_rect895 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect896 || (_rect896 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 70.68,
    width: 0.78,
    height: 2.33
  })), _rect897 || (_rect897 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect898 || (_rect898 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect899 || (_rect899 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 80,
    width: 0.78,
    height: 0.78
  })), _rect900 || (_rect900 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.24,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect901 || (_rect901 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect902 || (_rect902 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 27.19,
    width: 0.78,
    height: 5.44
  })), _rect903 || (_rect903 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 34.96,
    width: 0.78,
    height: 0.78
  })), _rect904 || (_rect904 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 36.51,
    width: 0.78,
    height: 1.55
  })), _rect905 || (_rect905 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 38.84,
    width: 0.78,
    height: 0.78
  })), _rect906 || (_rect906 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect907 || (_rect907 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 43.5,
    width: 0.78,
    height: 4.66
  })), _rect908 || (_rect908 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 48.94,
    width: 0.78,
    height: 2.33
  })), _rect909 || (_rect909 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 52.04,
    width: 0.78,
    height: 1.55
  })), _rect910 || (_rect910 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 54.37,
    width: 0.78,
    height: 3.88
  })), _rect911 || (_rect911 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 59.81,
    width: 0.78,
    height: 3.88
  })), _rect912 || (_rect912 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect913 || (_rect913 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 67.57,
    width: 0.78,
    height: 1.55
  })), _rect914 || (_rect914 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 69.9,
    width: 0.78,
    height: 0.78
  })), _rect915 || (_rect915 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 71.46,
    width: 0.78,
    height: 3.11
  })), _rect916 || (_rect916 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 75.34,
    width: 0.78,
    height: 3.88
  })), _rect917 || (_rect917 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.02,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect918 || (_rect918 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect919 || (_rect919 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 27.19,
    width: 0.78,
    height: 1.55
  })), _rect920 || (_rect920 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 29.52,
    width: 0.78,
    height: 0.78
  })), _rect921 || (_rect921 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 31.85,
    width: 0.78,
    height: 2.33
  })), _rect922 || (_rect922 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 34.96,
    width: 0.78,
    height: 2.33
  })), _rect923 || (_rect923 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 39.62,
    width: 0.78,
    height: 0.78
  })), _rect924 || (_rect924 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect925 || (_rect925 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 42.72,
    width: 0.78,
    height: 0.78
  })), _rect926 || (_rect926 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 45.05,
    width: 0.78,
    height: 0.78
  })), _rect927 || (_rect927 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 46.61,
    width: 0.78,
    height: 0.78
  })), _rect928 || (_rect928 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect929 || (_rect929 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 52.04,
    width: 0.78,
    height: 0.78
  })), _rect930 || (_rect930 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 53.6,
    width: 0.78,
    height: 2.33
  })), _rect931 || (_rect931 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect932 || (_rect932 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 59.81,
    width: 0.78,
    height: 0.78
  })), _rect933 || (_rect933 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 61.36,
    width: 0.78,
    height: 0.78
  })), _rect934 || (_rect934 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect935 || (_rect935 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect936 || (_rect936 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 66.02,
    width: 0.78,
    height: 1.55
  })), _rect937 || (_rect937 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect938 || (_rect938 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 72.23,
    width: 0.78,
    height: 1.55
  })), _rect939 || (_rect939 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect940 || (_rect940 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.79,
    y: 78.45,
    width: 0.78,
    height: 1.55
  })), _rect941 || (_rect941 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 26.41,
    width: 0.78,
    height: 0.78
  })), _rect942 || (_rect942 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 27.97,
    width: 0.78,
    height: 0.78
  })), _rect943 || (_rect943 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 29.52,
    width: 0.78,
    height: 2.33
  })), _rect944 || (_rect944 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 32.63,
    width: 0.78,
    height: 0.78
  })), _rect945 || (_rect945 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 34.96,
    width: 0.78,
    height: 0.78
  })), _rect946 || (_rect946 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 36.51,
    width: 0.78,
    height: 0.78
  })), _rect947 || (_rect947 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 38.06,
    width: 0.78,
    height: 2.33
  })), _rect948 || (_rect948 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect949 || (_rect949 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 43.5,
    width: 0.78,
    height: 3.11
  })), _rect950 || (_rect950 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect951 || (_rect951 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect952 || (_rect952 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 52.04,
    width: 0.78,
    height: 1.55
  })), _rect953 || (_rect953 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 55.15,
    width: 0.78,
    height: 0.78
  })), _rect954 || (_rect954 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 56.7,
    width: 0.78,
    height: 2.33
  })), _rect955 || (_rect955 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 60.58,
    width: 0.78,
    height: 0.78
  })), _rect956 || (_rect956 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect957 || (_rect957 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 64.47,
    width: 0.78,
    height: 2.33
  })), _rect958 || (_rect958 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 68.35,
    width: 0.78,
    height: 1.55
  })), _rect959 || (_rect959 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 70.68,
    width: 0.78,
    height: 1.55
  })), _rect960 || (_rect960 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 73.01,
    width: 0.78,
    height: 0.78
  })), _rect961 || (_rect961 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect962 || (_rect962 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect963 || (_rect963 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect964 || (_rect964 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 27.97,
    width: 0.78,
    height: 0.78
  })), _rect965 || (_rect965 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 29.52,
    width: 0.78,
    height: 0.78
  })), _rect966 || (_rect966 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 31.07,
    width: 0.78,
    height: 0.78
  })), _rect967 || (_rect967 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 34.18,
    width: 0.78,
    height: 3.88
  })), _rect968 || (_rect968 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 39.62,
    width: 0.78,
    height: 2.33
  })), _rect969 || (_rect969 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 42.72,
    width: 0.78,
    height: 2.33
  })), _rect970 || (_rect970 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 45.83,
    width: 0.78,
    height: 0.78
  })), _rect971 || (_rect971 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 48.16,
    width: 0.78,
    height: 1.55
  })), _rect972 || (_rect972 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 52.82,
    width: 0.78,
    height: 0.78
  })), _rect973 || (_rect973 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 54.37,
    width: 0.78,
    height: 0.78
  })), _rect974 || (_rect974 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect975 || (_rect975 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 58.25,
    width: 0.78,
    height: 1.55
  })), _rect976 || (_rect976 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 60.58,
    width: 0.78,
    height: 0.78
  })), _rect977 || (_rect977 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect978 || (_rect978 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect979 || (_rect979 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect980 || (_rect980 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 67.57,
    width: 0.78,
    height: 0.78
  })), _rect981 || (_rect981 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect982 || (_rect982 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect983 || (_rect983 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 73.01,
    width: 0.78,
    height: 1.55
  })), _rect984 || (_rect984 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 76.12,
    width: 0.78,
    height: 3.11
  })), _rect985 || (_rect985 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.35,
    y: 80,
    width: 0.78,
    height: 1.55
  })), _rect986 || (_rect986 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 25.64,
    width: 0.78,
    height: 2.33
  })), _rect987 || (_rect987 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 28.74,
    width: 0.78,
    height: 3.11
  })), _rect988 || (_rect988 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 34.18,
    width: 0.78,
    height: 3.11
  })), _rect989 || (_rect989 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 38.84,
    width: 0.78,
    height: 0.78
  })), _rect990 || (_rect990 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 42.72,
    width: 0.78,
    height: 0.78
  })), _rect991 || (_rect991 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 45.05,
    width: 0.78,
    height: 0.78
  })), _rect992 || (_rect992 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 46.61,
    width: 0.78,
    height: 0.78
  })), _rect993 || (_rect993 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 48.16,
    width: 0.78,
    height: 2.33
  })), _rect994 || (_rect994 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 52.82,
    width: 0.78,
    height: 0.78
  })), _rect995 || (_rect995 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 54.37,
    width: 0.78,
    height: 2.33
  })), _rect996 || (_rect996 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 57.48,
    width: 0.78,
    height: 0.78
  })), _rect997 || (_rect997 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 59.03,
    width: 0.78,
    height: 0.78
  })), _rect998 || (_rect998 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 60.58,
    width: 0.78,
    height: 0.78
  })), _rect999 || (_rect999 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 62.14,
    width: 0.78,
    height: 1.55
  })), _rect1000 || (_rect1000 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 65.24,
    width: 0.78,
    height: 0.78
  })), _rect1001 || (_rect1001 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 66.8,
    width: 0.78,
    height: 0.78
  })), _rect1002 || (_rect1002 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 68.35,
    width: 0.78,
    height: 0.78
  })), _rect1003 || (_rect1003 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect1004 || (_rect1004 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 73.01,
    width: 0.78,
    height: 2.33
  })), _rect1005 || (_rect1005 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.12,
    y: 76.12,
    width: 0.78,
    height: 5.44
  })), _rect1006 || (_rect1006 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect1007 || (_rect1007 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect1008 || (_rect1008 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 36.51,
    width: 0.78,
    height: 0.78
  })), _rect1009 || (_rect1009 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 38.06,
    width: 0.78,
    height: 2.33
  })), _rect1010 || (_rect1010 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 41.95,
    width: 0.78,
    height: 1.55
  })), _rect1011 || (_rect1011 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 44.28,
    width: 0.78,
    height: 1.55
  })), _rect1012 || (_rect1012 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 46.61,
    width: 0.78,
    height: 0.78
  })), _rect1013 || (_rect1013 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 48.16,
    width: 0.78,
    height: 0.78
  })), _rect1014 || (_rect1014 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 53.6,
    width: 0.78,
    height: 1.55
  })), _rect1015 || (_rect1015 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 56.7,
    width: 0.78,
    height: 2.33
  })), _rect1016 || (_rect1016 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 60.58,
    width: 0.78,
    height: 0.78
  })), _rect1017 || (_rect1017 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 62.91,
    width: 0.78,
    height: 2.33
  })), _rect1018 || (_rect1018 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect1019 || (_rect1019 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect1020 || (_rect1020 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect1021 || (_rect1021 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 73.01,
    width: 0.78,
    height: 5.44
  })), _rect1022 || (_rect1022 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 80,
    width: 0.78,
    height: 0.78
  })), _rect1023 || (_rect1023 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 245.9,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect1024 || (_rect1024 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect1025 || (_rect1025 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 30.3,
    width: 0.78,
    height: 1.55
  })), _rect1026 || (_rect1026 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect1027 || (_rect1027 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 35.73,
    width: 0.78,
    height: 0.78
  })), _rect1028 || (_rect1028 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 38.84,
    width: 0.78,
    height: 0.78
  })), _rect1029 || (_rect1029 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 40.39,
    width: 0.78,
    height: 0.78
  })), _rect1030 || (_rect1030 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect1031 || (_rect1031 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 44.28,
    width: 0.78,
    height: 1.55
  })), _rect1032 || (_rect1032 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 46.61,
    width: 0.78,
    height: 2.33
  })), _rect1033 || (_rect1033 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 49.71,
    width: 0.78,
    height: 2.33
  })), _rect1034 || (_rect1034 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 54.37,
    width: 0.78,
    height: 0.78
  })), _rect1035 || (_rect1035 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 55.92,
    width: 0.78,
    height: 0.78
  })), _rect1036 || (_rect1036 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 57.48,
    width: 0.78,
    height: 2.33
  })), _rect1037 || (_rect1037 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 60.58,
    width: 0.78,
    height: 1.55
  })), _rect1038 || (_rect1038 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect1039 || (_rect1039 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 64.47,
    width: 0.78,
    height: 4.66
  })), _rect1040 || (_rect1040 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 69.9,
    width: 0.78,
    height: 0.78
  })), _rect1041 || (_rect1041 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 71.46,
    width: 0.78,
    height: 0.78
  })), _rect1042 || (_rect1042 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 73.79,
    width: 0.78,
    height: 0.78
  })), _rect1043 || (_rect1043 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 75.34,
    width: 0.78,
    height: 1.55
  })), _rect1044 || (_rect1044 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 77.67,
    width: 0.78,
    height: 2.33
  })), _rect1045 || (_rect1045 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.68,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect1046 || (_rect1046 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 27.19,
    width: 0.78,
    height: 0.78
  })), _rect1047 || (_rect1047 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect1048 || (_rect1048 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 34.18,
    width: 0.78,
    height: 0.78
  })), _rect1049 || (_rect1049 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 38.84,
    width: 0.78,
    height: 0.78
  })), _rect1050 || (_rect1050 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 40.39,
    width: 0.78,
    height: 2.33
  })), _rect1051 || (_rect1051 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 43.5,
    width: 0.78,
    height: 0.78
  })), _rect1052 || (_rect1052 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 46.61,
    width: 0.78,
    height: 0.78
  })), _rect1053 || (_rect1053 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 49.71,
    width: 0.78,
    height: 0.78
  })), _rect1054 || (_rect1054 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 53.6,
    width: 0.78,
    height: 0.78
  })), _rect1055 || (_rect1055 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 55.15,
    width: 0.78,
    height: 1.55
  })), _rect1056 || (_rect1056 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 61.36,
    width: 0.78,
    height: 0.78
  })), _rect1057 || (_rect1057 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 63.69,
    width: 0.78,
    height: 0.78
  })), _rect1058 || (_rect1058 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 65.24,
    width: 0.78,
    height: 0.78
  })), _rect1059 || (_rect1059 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 66.8,
    width: 0.78,
    height: 0.78
  })), _rect1060 || (_rect1060 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 69.13,
    width: 0.78,
    height: 1.55
  })), _rect1061 || (_rect1061 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 71.46,
    width: 0.78,
    height: 1.55
  })), _rect1062 || (_rect1062 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.45,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect1063 || (_rect1063 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 27.19,
    width: 0.78,
    height: 0.78
  })), _rect1064 || (_rect1064 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 29.52,
    width: 0.78,
    height: 1.55
  })), _rect1065 || (_rect1065 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect1066 || (_rect1066 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 39.62,
    width: 0.78,
    height: 1.55
  })), _rect1067 || (_rect1067 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect1068 || (_rect1068 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 44.28,
    width: 0.78,
    height: 1.55
  })), _rect1069 || (_rect1069 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 47.38,
    width: 0.78,
    height: 1.55
  })), _rect1070 || (_rect1070 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 55.92,
    width: 0.78,
    height: 0.78
  })), _rect1071 || (_rect1071 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 59.03,
    width: 0.78,
    height: 0.78
  })), _rect1072 || (_rect1072 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 62.14,
    width: 0.78,
    height: 0.78
  })), _rect1073 || (_rect1073 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 63.69,
    width: 0.78,
    height: 2.33
  })), _rect1074 || (_rect1074 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 66.8,
    width: 0.78,
    height: 1.55
  })), _rect1075 || (_rect1075 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 69.9,
    width: 0.78,
    height: 2.33
  })), _rect1076 || (_rect1076 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 73.01,
    width: 0.78,
    height: 2.33
  })), _rect1077 || (_rect1077 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 76.12,
    width: 0.78,
    height: 0.78
  })), _rect1078 || (_rect1078 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 77.67,
    width: 0.78,
    height: 0.78
  })), _rect1079 || (_rect1079 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.23,
    y: 79.22,
    width: 0.78,
    height: 2.33
  })), _rect1080 || (_rect1080 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 26.41,
    width: 0.78,
    height: 1.55
  })), _rect1081 || (_rect1081 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 31.07,
    width: 0.78,
    height: 1.55
  })), _rect1082 || (_rect1082 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 34.18,
    width: 0.78,
    height: 0.78
  })), _rect1083 || (_rect1083 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 36.51,
    width: 0.78,
    height: 1.55
  })), _rect1084 || (_rect1084 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 38.84,
    width: 0.78,
    height: 2.33
  })), _rect1085 || (_rect1085 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 42.72,
    width: 0.78,
    height: 2.33
  })), _rect1086 || (_rect1086 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 45.83,
    width: 0.78,
    height: 3.11
  })), _rect1087 || (_rect1087 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 49.71,
    width: 0.78,
    height: 2.33
  })), _rect1088 || (_rect1088 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 53.6,
    width: 0.78,
    height: 0.78
  })), _rect1089 || (_rect1089 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 55.15,
    width: 0.78,
    height: 0.78
  })), _rect1090 || (_rect1090 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 57.48,
    width: 0.78,
    height: 3.88
  })), _rect1091 || (_rect1091 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 62.14,
    width: 0.78,
    height: 1.55
  })), _rect1092 || (_rect1092 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 65.24,
    width: 0.78,
    height: 0.78
  })), _rect1093 || (_rect1093 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 66.8,
    width: 0.78,
    height: 2.33
  })), _rect1094 || (_rect1094 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 71.46,
    width: 0.78,
    height: 0.78
  })), _rect1095 || (_rect1095 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 73.01,
    width: 0.78,
    height: 0.78
  })), _rect1096 || (_rect1096 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 74.56,
    width: 0.78,
    height: 0.78
  })), _rect1097 || (_rect1097 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 76.12,
    width: 0.78,
    height: 3.88
  })), _rect1098 || (_rect1098 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.01,
    y: 80.78,
    width: 0.78,
    height: 0.78
  })), _rect1099 || (_rect1099 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 26.41,
    width: 0.78,
    height: 1.55
  })), _rect1100 || (_rect1100 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 29.52,
    width: 0.78,
    height: 1.55
  })), _rect1101 || (_rect1101 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 34.96,
    width: 0.78,
    height: 1.55
  })), _rect1102 || (_rect1102 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 37.29,
    width: 0.78,
    height: 1.55
  })), _rect1103 || (_rect1103 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 40.39,
    width: 0.78,
    height: 1.55
  })), _rect1104 || (_rect1104 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 43.5,
    width: 0.78,
    height: 1.55
  })), _rect1105 || (_rect1105 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 46.61,
    width: 0.78,
    height: 0.78
  })), _rect1106 || (_rect1106 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect1107 || (_rect1107 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 52.04,
    width: 0.78,
    height: 0.78
  })), _rect1108 || (_rect1108 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 53.6,
    width: 0.78,
    height: 0.78
  })), _rect1109 || (_rect1109 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 55.15,
    width: 0.78,
    height: 1.55
  })), _rect1110 || (_rect1110 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 59.03,
    width: 0.78,
    height: 3.11
  })), _rect1111 || (_rect1111 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 66.02,
    width: 0.78,
    height: 2.33
  })), _rect1112 || (_rect1112 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect1113 || (_rect1113 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect1114 || (_rect1114 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 72.23,
    width: 0.78,
    height: 0.78
  })), _rect1115 || (_rect1115 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 73.79,
    width: 0.78,
    height: 1.55
  })), _rect1116 || (_rect1116 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 76.89,
    width: 0.78,
    height: 2.33
  })), _rect1117 || (_rect1117 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.78,
    y: 80,
    width: 0.78,
    height: 0.78
  })), _rect1118 || (_rect1118 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect1119 || (_rect1119 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 28.74,
    width: 0.78,
    height: 1.55
  })), _rect1120 || (_rect1120 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 31.07,
    width: 0.78,
    height: 0.78
  })), _rect1121 || (_rect1121 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 34.18,
    width: 0.78,
    height: 3.11
  })), _rect1122 || (_rect1122 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 38.84,
    width: 0.78,
    height: 0.78
  })), _rect1123 || (_rect1123 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 40.39,
    width: 0.78,
    height: 0.78
  })), _rect1124 || (_rect1124 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect1125 || (_rect1125 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 45.05,
    width: 0.78,
    height: 0.78
  })), _rect1126 || (_rect1126 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect1127 || (_rect1127 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect1128 || (_rect1128 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect1129 || (_rect1129 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 52.04,
    width: 0.78,
    height: 0.78
  })), _rect1130 || (_rect1130 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 53.6,
    width: 0.78,
    height: 0.78
  })), _rect1131 || (_rect1131 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 55.92,
    width: 0.78,
    height: 2.33
  })), _rect1132 || (_rect1132 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 59.03,
    width: 0.78,
    height: 0.78
  })), _rect1133 || (_rect1133 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 60.58,
    width: 0.78,
    height: 0.78
  })), _rect1134 || (_rect1134 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 62.91,
    width: 0.78,
    height: 2.33
  })), _rect1135 || (_rect1135 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 66.8,
    width: 0.78,
    height: 0.78
  })), _rect1136 || (_rect1136 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 69.9,
    width: 0.78,
    height: 0.78
  })), _rect1137 || (_rect1137 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 73.01,
    width: 0.78,
    height: 0.78
  })), _rect1138 || (_rect1138 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.56,
    y: 79.22,
    width: 0.78,
    height: 2.33
  })), _rect1139 || (_rect1139 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 25.64,
    width: 0.78,
    height: 1.55
  })), _rect1140 || (_rect1140 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 27.97,
    width: 0.78,
    height: 0.78
  })), _rect1141 || (_rect1141 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 29.52,
    width: 0.78,
    height: 1.55
  })), _rect1142 || (_rect1142 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 31.85,
    width: 0.78,
    height: 3.88
  })), _rect1143 || (_rect1143 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 36.51,
    width: 0.78,
    height: 0.78
  })), _rect1144 || (_rect1144 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 40.39,
    width: 0.78,
    height: 1.55
  })), _rect1145 || (_rect1145 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 42.72,
    width: 0.78,
    height: 0.78
  })), _rect1146 || (_rect1146 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 45.83,
    width: 0.78,
    height: 3.88
  })), _rect1147 || (_rect1147 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect1148 || (_rect1148 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 52.04,
    width: 0.78,
    height: 0.78
  })), _rect1149 || (_rect1149 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 53.6,
    width: 0.78,
    height: 0.78
  })), _rect1150 || (_rect1150 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 55.15,
    width: 0.78,
    height: 2.33
  })), _rect1151 || (_rect1151 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 58.25,
    width: 0.78,
    height: 0.78
  })), _rect1152 || (_rect1152 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 59.81,
    width: 0.78,
    height: 1.55
  })), _rect1153 || (_rect1153 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 62.14,
    width: 0.78,
    height: 1.55
  })), _rect1154 || (_rect1154 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 65.24,
    width: 0.78,
    height: 1.55
  })), _rect1155 || (_rect1155 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 72.23,
    width: 0.78,
    height: 0.78
  })), _rect1156 || (_rect1156 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 73.79,
    width: 0.78,
    height: 3.11
  })), _rect1157 || (_rect1157 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 78.45,
    width: 0.78,
    height: 1.55
  })), _rect1158 || (_rect1158 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 251.33,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect1159 || (_rect1159 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 26.41,
    width: 0.78,
    height: 0.78
  })), _rect1160 || (_rect1160 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 27.97,
    width: 0.78,
    height: 1.55
  })), _rect1161 || (_rect1161 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect1162 || (_rect1162 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 34.96,
    width: 0.78,
    height: 0.78
  })), _rect1163 || (_rect1163 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect1164 || (_rect1164 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 43.5,
    width: 0.78,
    height: 0.78
  })), _rect1165 || (_rect1165 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 45.83,
    width: 0.78,
    height: 2.33
  })), _rect1166 || (_rect1166 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 51.27,
    width: 0.78,
    height: 0.78
  })), _rect1167 || (_rect1167 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 52.82,
    width: 0.78,
    height: 3.88
  })), _rect1168 || (_rect1168 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 57.48,
    width: 0.78,
    height: 2.33
  })), _rect1169 || (_rect1169 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect1170 || (_rect1170 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect1171 || (_rect1171 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect1172 || (_rect1172 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect1173 || (_rect1173 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect1174 || (_rect1174 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 72.23,
    width: 0.78,
    height: 2.33
  })), _rect1175 || (_rect1175 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 76.89,
    width: 0.78,
    height: 1.55
  })), _rect1176 || (_rect1176 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.11,
    y: 79.22,
    width: 0.78,
    height: 2.33
  })), _rect1177 || (_rect1177 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 25.64,
    width: 0.78,
    height: 1.55
  })), _rect1178 || (_rect1178 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 27.97,
    width: 0.78,
    height: 0.78
  })), _rect1179 || (_rect1179 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 29.52,
    width: 0.78,
    height: 1.55
  })), _rect1180 || (_rect1180 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 31.85,
    width: 0.78,
    height: 2.33
  })), _rect1181 || (_rect1181 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 34.96,
    width: 0.78,
    height: 1.55
  })), _rect1182 || (_rect1182 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 38.06,
    width: 0.78,
    height: 0.78
  })), _rect1183 || (_rect1183 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 39.62,
    width: 0.78,
    height: 2.33
  })), _rect1184 || (_rect1184 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 42.72,
    width: 0.78,
    height: 1.55
  })), _rect1185 || (_rect1185 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 45.83,
    width: 0.78,
    height: 1.55
  })), _rect1186 || (_rect1186 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect1187 || (_rect1187 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 52.82,
    width: 0.78,
    height: 0.78
  })), _rect1188 || (_rect1188 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 58.25,
    width: 0.78,
    height: 0.78
  })), _rect1189 || (_rect1189 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 59.81,
    width: 0.78,
    height: 2.33
  })), _rect1190 || (_rect1190 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 62.91,
    width: 0.78,
    height: 1.55
  })), _rect1191 || (_rect1191 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect1192 || (_rect1192 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 67.57,
    width: 0.78,
    height: 0.78
  })), _rect1193 || (_rect1193 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 69.13,
    width: 0.78,
    height: 1.55
  })), _rect1194 || (_rect1194 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 72.23,
    width: 0.78,
    height: 0.78
  })), _rect1195 || (_rect1195 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect1196 || (_rect1196 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.89,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect1197 || (_rect1197 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 27.97,
    width: 0.78,
    height: 1.55
  })), _rect1198 || (_rect1198 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect1199 || (_rect1199 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect1200 || (_rect1200 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 34.96,
    width: 0.78,
    height: 1.55
  })), _rect1201 || (_rect1201 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 37.29,
    width: 0.78,
    height: 1.55
  })), _rect1202 || (_rect1202 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 39.62,
    width: 0.78,
    height: 0.78
  })), _rect1203 || (_rect1203 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect1204 || (_rect1204 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 44.28,
    width: 0.78,
    height: 2.33
  })), _rect1205 || (_rect1205 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 48.94,
    width: 0.78,
    height: 3.11
  })), _rect1206 || (_rect1206 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect1207 || (_rect1207 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 58.25,
    width: 0.78,
    height: 0.78
  })), _rect1208 || (_rect1208 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 59.81,
    width: 0.78,
    height: 0.78
  })), _rect1209 || (_rect1209 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 63.69,
    width: 0.78,
    height: 0.78
  })), _rect1210 || (_rect1210 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 65.24,
    width: 0.78,
    height: 1.55
  })), _rect1211 || (_rect1211 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 72.23,
    width: 0.78,
    height: 1.55
  })), _rect1212 || (_rect1212 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 74.56,
    width: 0.78,
    height: 0.78
  })), _rect1213 || (_rect1213 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 79.22,
    width: 0.78,
    height: 0.78
  })), _rect1214 || (_rect1214 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.66,
    y: 80.78,
    width: 0.78,
    height: 0.78
  })), _rect1215 || (_rect1215 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect1216 || (_rect1216 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 28.74,
    width: 0.78,
    height: 0.78
  })), _rect1217 || (_rect1217 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect1218 || (_rect1218 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 33.4,
    width: 0.78,
    height: 0.78
  })), _rect1219 || (_rect1219 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 34.96,
    width: 0.78,
    height: 0.78
  })), _rect1220 || (_rect1220 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 38.06,
    width: 0.78,
    height: 0.78
  })), _rect1221 || (_rect1221 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 40.39,
    width: 0.78,
    height: 0.78
  })), _rect1222 || (_rect1222 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 44.28,
    width: 0.78,
    height: 3.88
  })), _rect1223 || (_rect1223 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect1224 || (_rect1224 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 55.15,
    width: 0.78,
    height: 0.78
  })), _rect1225 || (_rect1225 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 56.7,
    width: 0.78,
    height: 1.55
  })), _rect1226 || (_rect1226 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 59.03,
    width: 0.78,
    height: 4.66
  })), _rect1227 || (_rect1227 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 65.24,
    width: 0.78,
    height: 2.33
  })), _rect1228 || (_rect1228 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 69.9,
    width: 0.78,
    height: 0.78
  })), _rect1229 || (_rect1229 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 75.34,
    width: 0.78,
    height: 3.88
  })), _rect1230 || (_rect1230 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.44,
    y: 80.78,
    width: 0.78,
    height: 1.55
  })), _rect1231 || (_rect1231 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 33.4,
    width: 0.78,
    height: 1.55
  })), _rect1232 || (_rect1232 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 35.73,
    width: 0.78,
    height: 3.11
  })), _rect1233 || (_rect1233 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 39.62,
    width: 0.78,
    height: 0.78
  })), _rect1234 || (_rect1234 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 41.17,
    width: 0.78,
    height: 0.78
  })), _rect1235 || (_rect1235 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 42.72,
    width: 0.78,
    height: 2.33
  })), _rect1236 || (_rect1236 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect1237 || (_rect1237 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 51.27,
    width: 0.78,
    height: 0.78
  })), _rect1238 || (_rect1238 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 55.92,
    width: 0.78,
    height: 2.33
  })), _rect1239 || (_rect1239 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 59.03,
    width: 0.78,
    height: 1.55
  })), _rect1240 || (_rect1240 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 62.91,
    width: 0.78,
    height: 0.78
  })), _rect1241 || (_rect1241 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 67.57,
    width: 0.78,
    height: 0.78
  })), _rect1242 || (_rect1242 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 69.13,
    width: 0.78,
    height: 1.55
  })), _rect1243 || (_rect1243 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 72.23,
    width: 0.78,
    height: 1.55
  })), _rect1244 || (_rect1244 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect1245 || (_rect1245 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect1246 || (_rect1246 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.22,
    y: 80.78,
    width: 0.78,
    height: 0.78
  })), _rect1247 || (_rect1247 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 25.64,
    width: 0.78,
    height: 5.44
  })), _rect1248 || (_rect1248 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 31.85,
    width: 0.78,
    height: 1.55
  })), _rect1249 || (_rect1249 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 34.18,
    width: 0.78,
    height: 1.55
  })), _rect1250 || (_rect1250 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 36.51,
    width: 0.78,
    height: 0.78
  })), _rect1251 || (_rect1251 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 38.06,
    width: 0.78,
    height: 0.78
  })), _rect1252 || (_rect1252 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 40.39,
    width: 0.78,
    height: 1.55
  })), _rect1253 || (_rect1253 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect1254 || (_rect1254 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 45.83,
    width: 0.78,
    height: 0.78
  })), _rect1255 || (_rect1255 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 47.38,
    width: 0.78,
    height: 1.55
  })), _rect1256 || (_rect1256 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 49.71,
    width: 0.78,
    height: 3.11
  })), _rect1257 || (_rect1257 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect1258 || (_rect1258 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 58.25,
    width: 0.78,
    height: 0.78
  })), _rect1259 || (_rect1259 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 59.81,
    width: 0.78,
    height: 0.78
  })), _rect1260 || (_rect1260 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 61.36,
    width: 0.78,
    height: 0.78
  })), _rect1261 || (_rect1261 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 62.91,
    width: 0.78,
    height: 1.55
  })), _rect1262 || (_rect1262 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 69.9,
    width: 0.78,
    height: 0.78
  })), _rect1263 || (_rect1263 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 73.79,
    width: 0.78,
    height: 0.78
  })), _rect1264 || (_rect1264 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect1265 || (_rect1265 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect1266 || (_rect1266 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.99,
    y: 78.45,
    width: 0.78,
    height: 3.11
  })), _rect1267 || (_rect1267 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect1268 || (_rect1268 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect1269 || (_rect1269 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 31.85,
    width: 0.78,
    height: 1.55
  })), _rect1270 || (_rect1270 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 36.51,
    width: 0.78,
    height: 1.55
  })), _rect1271 || (_rect1271 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 40.39,
    width: 0.78,
    height: 0.78
  })), _rect1272 || (_rect1272 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 41.95,
    width: 0.78,
    height: 1.55
  })), _rect1273 || (_rect1273 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect1274 || (_rect1274 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect1275 || (_rect1275 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 48.94,
    width: 0.78,
    height: 0.78
  })), _rect1276 || (_rect1276 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect1277 || (_rect1277 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 52.04,
    width: 0.78,
    height: 1.55
  })), _rect1278 || (_rect1278 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 55.15,
    width: 0.78,
    height: 1.55
  })), _rect1279 || (_rect1279 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 58.25,
    width: 0.78,
    height: 0.78
  })), _rect1280 || (_rect1280 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 59.81,
    width: 0.78,
    height: 0.78
  })), _rect1281 || (_rect1281 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 62.91,
    width: 0.78,
    height: 2.33
  })), _rect1282 || (_rect1282 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 66.8,
    width: 0.78,
    height: 0.78
  })), _rect1283 || (_rect1283 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 71.46,
    width: 0.78,
    height: 0.78
  })), _rect1284 || (_rect1284 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 73.01,
    width: 0.78,
    height: 0.78
  })), _rect1285 || (_rect1285 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect1286 || (_rect1286 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect1287 || (_rect1287 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 256.77,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _rect1288 || (_rect1288 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect1289 || (_rect1289 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 27.19,
    width: 0.78,
    height: 2.33
  })), _rect1290 || (_rect1290 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect1291 || (_rect1291 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect1292 || (_rect1292 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 34.18,
    width: 0.78,
    height: 0.78
  })), _rect1293 || (_rect1293 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 35.73,
    width: 0.78,
    height: 0.78
  })), _rect1294 || (_rect1294 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 37.29,
    width: 0.78,
    height: 0.78
  })), _rect1295 || (_rect1295 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 38.84,
    width: 0.78,
    height: 3.11
  })), _rect1296 || (_rect1296 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 44.28,
    width: 0.78,
    height: 3.88
  })), _rect1297 || (_rect1297 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 49.71,
    width: 0.78,
    height: 0.78
  })), _rect1298 || (_rect1298 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 51.27,
    width: 0.78,
    height: 0.78
  })), _rect1299 || (_rect1299 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 53.6,
    width: 0.78,
    height: 1.55
  })), _rect1300 || (_rect1300 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 56.7,
    width: 0.78,
    height: 1.55
  })), _rect1301 || (_rect1301 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 59.81,
    width: 0.78,
    height: 3.88
  })), _rect1302 || (_rect1302 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 66.02,
    width: 0.78,
    height: 2.33
  })), _rect1303 || (_rect1303 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 69.13,
    width: 0.78,
    height: 1.55
  })), _rect1304 || (_rect1304 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 71.46,
    width: 0.78,
    height: 0.78
  })), _rect1305 || (_rect1305 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 73.01,
    width: 0.78,
    height: 1.55
  })), _rect1306 || (_rect1306 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.55,
    y: 75.34,
    width: 0.78,
    height: 6.21
  })), _rect1307 || (_rect1307 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect1308 || (_rect1308 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 27.19,
    width: 0.78,
    height: 2.33
  })), _rect1309 || (_rect1309 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect1310 || (_rect1310 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect1311 || (_rect1311 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 33.4,
    width: 0.78,
    height: 1.55
  })), _rect1312 || (_rect1312 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 36.51,
    width: 0.78,
    height: 0.78
  })), _rect1313 || (_rect1313 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 38.06,
    width: 0.78,
    height: 0.78
  })), _rect1314 || (_rect1314 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 42.72,
    width: 0.78,
    height: 1.55
  })), _rect1315 || (_rect1315 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 45.83,
    width: 0.78,
    height: 1.55
  })), _rect1316 || (_rect1316 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 48.94,
    width: 0.78,
    height: 1.55
  })), _rect1317 || (_rect1317 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 51.27,
    width: 0.78,
    height: 3.11
  })), _rect1318 || (_rect1318 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 55.15,
    width: 0.78,
    height: 0.78
  })), _rect1319 || (_rect1319 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 58.25,
    width: 0.78,
    height: 0.78
  })), _rect1320 || (_rect1320 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 60.58,
    width: 0.78,
    height: 2.33
  })), _rect1321 || (_rect1321 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect1322 || (_rect1322 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect1323 || (_rect1323 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 70.68,
    width: 0.78,
    height: 0.78
  })), _rect1324 || (_rect1324 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 72.23,
    width: 0.78,
    height: 0.78
  })), _rect1325 || (_rect1325 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect1326 || (_rect1326 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect1327 || (_rect1327 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.32,
    y: 79.22,
    width: 0.78,
    height: 2.33
  })), _rect1328 || (_rect1328 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect1329 || (_rect1329 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 27.19,
    width: 0.78,
    height: 2.33
  })), _rect1330 || (_rect1330 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect1331 || (_rect1331 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 31.85,
    width: 0.78,
    height: 0.78
  })), _rect1332 || (_rect1332 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 33.4,
    width: 0.78,
    height: 1.55
  })), _rect1333 || (_rect1333 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 35.73,
    width: 0.78,
    height: 0.78
  })), _rect1334 || (_rect1334 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 37.29,
    width: 0.78,
    height: 0.78
  })), _rect1335 || (_rect1335 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 39.62,
    width: 0.78,
    height: 2.33
  })), _rect1336 || (_rect1336 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 45.83,
    width: 0.78,
    height: 0.78
  })), _rect1337 || (_rect1337 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 48.94,
    width: 0.78,
    height: 1.55
  })), _rect1338 || (_rect1338 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 51.27,
    width: 0.78,
    height: 0.78
  })), _rect1339 || (_rect1339 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 55.15,
    width: 0.78,
    height: 0.78
  })), _rect1340 || (_rect1340 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect1341 || (_rect1341 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 58.25,
    width: 0.78,
    height: 2.33
  })), _rect1342 || (_rect1342 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 61.36,
    width: 0.78,
    height: 1.55
  })), _rect1343 || (_rect1343 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 63.69,
    width: 0.78,
    height: 2.33
  })), _rect1344 || (_rect1344 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 69.13,
    width: 0.78,
    height: 0.78
  })), _rect1345 || (_rect1345 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 70.68,
    width: 0.78,
    height: 2.33
  })), _rect1346 || (_rect1346 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 73.79,
    width: 0.78,
    height: 0.78
  })), _rect1347 || (_rect1347 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.1,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect1348 || (_rect1348 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 25.64,
    width: 0.78,
    height: 0.78
  })), _rect1349 || (_rect1349 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 30.3,
    width: 0.78,
    height: 0.78
  })), _rect1350 || (_rect1350 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 35.73,
    width: 0.78,
    height: 1.55
  })), _rect1351 || (_rect1351 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 38.06,
    width: 0.78,
    height: 0.78
  })), _rect1352 || (_rect1352 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 39.62,
    width: 0.78,
    height: 2.33
  })), _rect1353 || (_rect1353 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 44.28,
    width: 0.78,
    height: 0.78
  })), _rect1354 || (_rect1354 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 45.83,
    width: 0.78,
    height: 0.78
  })), _rect1355 || (_rect1355 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect1356 || (_rect1356 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 49.71,
    width: 0.78,
    height: 0.78
  })), _rect1357 || (_rect1357 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 52.04,
    width: 0.78,
    height: 1.55
  })), _rect1358 || (_rect1358 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 54.37,
    width: 0.78,
    height: 1.55
  })), _rect1359 || (_rect1359 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 57.48,
    width: 0.78,
    height: 1.55
  })), _rect1360 || (_rect1360 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 59.81,
    width: 0.78,
    height: 0.78
  })), _rect1361 || (_rect1361 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 61.36,
    width: 0.78,
    height: 0.78
  })), _rect1362 || (_rect1362 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 63.69,
    width: 0.78,
    height: 1.55
  })), _rect1363 || (_rect1363 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect1364 || (_rect1364 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 68.35,
    width: 0.78,
    height: 2.33
  })), _rect1365 || (_rect1365 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 72.23,
    width: 0.78,
    height: 0.78
  })), _rect1366 || (_rect1366 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 73.79,
    width: 0.78,
    height: 0.78
  })), _rect1367 || (_rect1367 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect1368 || (_rect1368 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 76.89,
    width: 0.78,
    height: 0.78
  })), _rect1369 || (_rect1369 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.88,
    y: 78.45,
    width: 0.78,
    height: 0.78
  })), _rect1370 || (_rect1370 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 25.64,
    width: 0.78,
    height: 5.44
  })), _rect1371 || (_rect1371 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 34.18,
    width: 0.78,
    height: 1.55
  })), _rect1372 || (_rect1372 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 36.51,
    width: 0.78,
    height: 2.33
  })), _rect1373 || (_rect1373 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 41.95,
    width: 0.78,
    height: 0.78
  })), _rect1374 || (_rect1374 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 44.28,
    width: 0.78,
    height: 2.33
  })), _rect1375 || (_rect1375 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 47.38,
    width: 0.78,
    height: 0.78
  })), _rect1376 || (_rect1376 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 50.49,
    width: 0.78,
    height: 0.78
  })), _rect1377 || (_rect1377 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 52.04,
    width: 0.78,
    height: 3.11
  })), _rect1378 || (_rect1378 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 56.7,
    width: 0.78,
    height: 0.78
  })), _rect1379 || (_rect1379 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 58.25,
    width: 0.78,
    height: 0.78
  })), _rect1380 || (_rect1380 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 59.81,
    width: 0.78,
    height: 3.11
  })), _rect1381 || (_rect1381 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 64.47,
    width: 0.78,
    height: 0.78
  })), _rect1382 || (_rect1382 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 66.02,
    width: 0.78,
    height: 0.78
  })), _rect1383 || (_rect1383 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 67.57,
    width: 0.78,
    height: 2.33
  })), _rect1384 || (_rect1384 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 70.68,
    width: 0.78,
    height: 2.33
  })), _rect1385 || (_rect1385 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 75.34,
    width: 0.78,
    height: 0.78
  })), _rect1386 || (_rect1386 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 77.67,
    width: 0.78,
    height: 3.11
  })), _rect1387 || (_rect1387 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.65,
    y: 81.55,
    width: 0.78,
    height: 0.78
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "339.38 249.57 314.58 208.24 289.78 249.57 339.38 249.57"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(204.86 116.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24"
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 9.83,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.69,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 30.46,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.53,
    y: 0
  }, "T SMA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 92.46,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 103.53,
    y: 0
  }, "T"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-27",
    transform: "translate(204.74 143.69)"
  }, "Our Global Presence:", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 0,
    y: 11.9
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.7,
    y: 11.9
  }, "ustralia: "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 31.64,
    y: 11.9
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 35.7,
    y: 11.9
  }, "ydney \u2022 Adelaide \u2022 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 94.04,
    y: 11.9
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 97.36,
    y: 11.9
  }, "asmania"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23.8
  }, "Bangladesh: "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 41.05,
    y: 23.8
  }, "Dhaka"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 35.7
  }, "Nepal: "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 22.15,
    y: 35.7
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 26.24,
    y: 35.7
  }, "athmandu \u2022 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 63.08,
    y: 35.7
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 67.1,
    y: 35.7
  }, "okhara \u2022 Chitwan"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 44.1
  }, "Birtamode \u2022 Butwal \u2022 Itahari \u2022 Damak"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52.5
  }, "Dharan \u2022 Biratnagar \u2022 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 66.23,
    y: 52.5
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 69.62,
    y: 52.5
  }, "ulsipur")))), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 183.48,
    y1: 195.72,
    x2: 339.38,
    y2: 195.72
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 183.48,
    y1: 139.02,
    x2: 339.38,
    y2: 139.02
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 183.48,
    y1: 82.33,
    x2: 339.38,
    y2: 82.33
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 183.48,
    y1: 25.64,
    x2: 339.38,
    y2: 25.64
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 183.48,
    y1: 224.06,
    x2: 339.38,
    y2: 224.06
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 183.48,
    y1: 167.37,
    x2: 339.38,
    y2: 167.37
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 183.48,
    y1: 110.68,
    x2: 339.38,
    y2: 110.68
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 183.48,
    y1: 53.98,
    x2: 339.38,
    y2: 53.98
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 289.78,
    y1: 249.57,
    x2: 289.78,
    y2: 0.13
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 233.08,
    y1: 249.57,
    x2: 233.08,
    y2: 0.13
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 318.12,
    y1: 249.57,
    x2: 318.12,
    y2: 0.13
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 261.43,
    y1: 249.57,
    x2: 261.43,
    y2: 0.13
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 204.74,
    y1: 249.57,
    x2: 204.74,
    y2: 0.13
  })), _rect1388 || (_rect1388 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 183.48,
    y: 0.13,
    width: 155.91,
    height: 249.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial1);
export default __webpack_public_path__ + "static/media/guideMaterial1.49b735c94b8a6842f897c2184fafb9cd.svg";
export { ForwardRef as ReactComponent };